<template>
  <div>
    <div class="row mb-2 pe-4">
      <div class="col-lg-8 col-md-7 col-7 d-flex align-items-center">
        <div class="color-common">
          <h3 class="title-page mb-0 ps-3">{{ $t('Slider_Images') }}</h3>
        </div>
      </div>
    </div>
    <div class="page-header align-items-start min-vh-100 my-transacions pb-5">
      <!-- <span class="mask bg-white"></span> -->
      <div class="container">
        <div class="row">
          <div class="notifications">
            <material-alert
              v-if="error"
              color="danger"
              icon="ni ni-like-2 ni-lg"
              dismissible
            >
              {{ error }}
            </material-alert>
          </div>
          <div class="col-lg-12 col-md-12 col-12 mx-auto mt-3">
            <div class="tab-list p-0">
              <ul id="general-tab" class="nav nav-tabs">
                <li class="nav-item">
                  <a
                    id="nav_item_1"
                    class="nav-link active"
                    @click="changeTab(1)"
                  >
                    Minty Member
                  </a>
                </li>
                <li class="nav-item">
                  <a id="nav_item_2" class="nav-link" @click="changeTab(2)">
                    Online Ordering
                  </a>
                </li>
                <li class="nav-item">
                  <a id="nav_item_3" class="nav-link" @click="changeTab(3)">
                    KIOSK
                  </a>
                </li>
                <li class="nav-item">
                  <a id="nav_item_4" class="nav-link" @click="changeTab(4)">
                    Outlet List
                  </a>
                </li>
              </ul>
            </div>
            <div id="slide_list" v-if="type == 1">
              <div class="row mt-3">
                <div class="col-lg-9 col-12 color-common d-flex align-items-center">
                  <h3 class="title-page mb-0 pe-2">Homepage Slider</h3>
                  <div>(Maximum 9 slides display on page at a time)</div>
                </div>
                <div class="col-lg-3 col-12 d-flex justify-content-end">
                  <material-button @click="saveSlide()" class="btn-background btn-sm">
                    Save
                  </material-button>
                </div>
              </div>
              <draggable 
                  v-model="slides" 
                  group="slides" 
                  @start="drag=true" 
                  @end="onEndDragSlide"
                  item-key="id"
                  class="row row-flex"
                >
                <template #item="{element, index}">
                  <div class="col-xl-4 col-lg-6 col-12">
                  <div class="slide-box" :class="{'slide-scheduled': !element.active}">
                    <div class="d-flex justify-content-between">
                      <div class="ps-0 text-title">
                        {{ $t('Image_Sequence') }}
                      </div>
                      <i
                        style="color: #f44335; font-size: 20px; cursor: pointer;"
                        class="fa fa-times icon-close-sidenav-main danger"
                        aria-hidden="true"
                        @click="removeRowSlide(index)"
                      ></i>
                    </div>
                    <div class="w-100 p-3">
                      <div class="dowload-img" v-show="urlImagePreview[index] || element.file_name">
                        <div id="preview" class="w-100" style="position: relative">
                          <img
                            class="image-url"
                            v-if="urlImagePreview[index] || element.file_name"
                            :src="urlImagePreview[index] ? urlImagePreview[index] : element.file_name"
                          />
                          <i
                            class="fa fa-times icon-close-sidenav-main danger"
                            v-if="urlImagePreview[index] || element.file_name"
                            style="
                              position: absolute;
                              color: #f44335;
                              font-size: 20px;
                              right: 5px;
                              top: 8px;
                            "
                            aria-hidden="true"
                            @click="clearImage(index)"
                          ></i>
                          <div class="btn-edit-img">
                            <i
                              class="fas fa-pencil-alt text-dark"
                              v-if="urlImagePreview[index] || element.file_name"
                              aria-hidden="true"
                              @click="uploadFile(index)"
                            ></i>
                          </div>
                          <div class="schedule-tag" v-if="!element.active">SCHEDULED</div>
                        </div>
                      </div>
                      <div
                        class="dowload-img"
                        @click="uploadFile(index)"
                        v-show="!urlImagePreview[index] && !element.file_name"
                      >
                        <material-input
                          style="display: none"
                          type="file"
                          :id="`image_${index}`"
                          @change="handleFileUpload($event, index)"
                          accept="image/*"
                        />
                        <i class="material-icons css-icon-upload mt-0">backup</i>
                        <h6>Click here to upload an image.</h6>
                      </div>
                      <div class="upload-size-hint">{{ $t('Recommended_Size_Banner') }}</div>
                      <div
                        class="is-invalid d-flex align-items-center pe-2"
                        v-if="fieldRequired.isImageRequire"
                      >
                        {{ messageImageError }}
                      </div>
                    </div>
                    <div class="slide-config">
                      <div>
                        <div class="ps-0 label-form mb-2">
                          {{ $t('Who_can_see_this_slide') }}
                        </div>
                        <Multiselect
                          v-model="element.slide_tiers"
                          mode="tags"
                          :close-on-select="false"
                          class="multiselect-slide"
                          :searchable="true"
                          :options="tiers"
                          placeholder="Select tiers can see"
                          :canClear="false"
                        />  
                      </div>
                      <div class="mt-3">
                        <div class="ps-0 label-form mb-2">
                          {{ $t('Display_Period') }}
                        </div>
                        <div class="d-flex align-items-center">
                          <div class="label-form pe-3 min-w-50px">{{ $t('From') }}</div>
                            <Datepicker
                              v-model="element.start_date"
                              :enableTimePicker="false"
                              class="date-time pe-3"
                              :disabled="alwaysDisplayChecked[index] == 'true' ? true : false"
                              :format="format"
                            />
                            <Datepicker
                              v-model="element.start_time"
                              timePicker
                              class="date-time"
                              :disabled="alwaysDisplayChecked[index] == 'true' ? true : false"
                            />
                        </div>
                        <div class="d-flex mt-2 align-items-center">
                          <div class="label-form pe-3 min-w-50px">{{ $t('To') }}</div>
                            <Datepicker
                              v-model="element.end_date"
                              :enableTimePicker="false"
                              class="date-time pe-3"
                              :disabled="alwaysDisplayChecked[index] == 'true' ? true : false"
                              :format="format"
                            />
                            <Datepicker
                              v-model="element.end_time"
                              timePicker
                              class="date-time"
                              :disabled="alwaysDisplayChecked[index] == 'true' ? true : false"
                            />
                        </div>
                        <div class="d-flex mt-2" v-if="fieldRequired[index].isDateRequire">
                          <div class="min-w-50px"></div>
                          <span
                            class="is-invalid"
                            >{{ textRequiredDateCustom[index] }}</span
                          >
                        </div>
                        <div class="d-flex mt-2">
                          <div class="min-w-50px"></div>
                          <material-checkbox
                            v-model="element.always_display"
                            :checked="element.always_display ? true : false"
                            :id="`always_display_${index}`"
                            class="align-items-center checkbox-custom"
                            @change="check($event, index)"
                          >
                            <template v-slot:label>
                              {{ $t('Always_Display') }}
                            </template>
                          </material-checkbox>
                        </div>
                      </div>
                      <div class="mt-3">
                        <div class="ps-0 label-form mb-2">
                          {{ $t('Destination_link') }}
                        </div>
                        <material-input
                          class="textarea-slide"
                          v-model="element.destination_link"
                          placeholder="Enter destination link"
                        />
                        <span
                          class="is-invalid"
                          v-if="fieldRequired[index].invalidLink"
                          >Invalid link.</span
                        >
                      </div>
                    </div>
                  </div>
                </div>
                </template>
              </draggable>
              <div class="d-flex justify-content-end mt-3" v-if="this.slides.length < 9">
                <a
                  @click="addRowSlide()"
                  class="text-decoration-underline tag-a-custom"
                  >Add Image</a
                >
              </div>

              <!-- MBR133: background of the member app's sign-in page, saved on its own. -->
              <div class="row mt-4">
                <div class="col-lg-9 col-12 color-common d-flex align-items-center">
                  <h3 class="title-page mb-0 pe-2">{{ $t('Member_Login_Background') }}</h3>
                </div>
                <div class="col-lg-3 col-12 d-flex justify-content-end">
                  <material-button @click="saveLoginBackground()" class="btn-background btn-sm">
                    Save
                  </material-button>
                </div>
              </div>
              <div class="row row-flex">
                <div class="col-xl-4 col-lg-6 col-12">
                  <div class="slide-box login-bg-box">
                    <div class="text-title">{{ $t('Member_Login_Background_Hint') }}</div>
                    <div class="w-100 p-3">
                      <div class="dowload-img portrait-45" v-show="loginBgPreview || loginBg">
                        <div class="w-100 h-100" style="position: relative">
                          <img
                            class="image-url portrait-45 login-bg-img"
                            v-if="loginBgPreview || loginBg"
                            :src="loginBgPreview || loginBg"
                          />
                          <i
                            class="fa fa-times icon-close-sidenav-main danger"
                            style="
                              position: absolute;
                              color: #f44335;
                              font-size: 20px;
                              right: 5px;
                              top: 8px;
                            "
                            aria-hidden="true"
                            @click="clearLoginBg()"
                          ></i>
                          <div class="btn-edit-img">
                            <i
                              class="fas fa-pencil-alt text-dark"
                              aria-hidden="true"
                              @click="uploadLoginBg()"
                            ></i>
                          </div>
                        </div>
                      </div>
                      <div
                        class="dowload-img portrait-45"
                        @click="uploadLoginBg()"
                        v-show="!loginBgPreview && !loginBg"
                      >
                        <i class="material-icons css-icon-upload mt-0">backup</i>
                        <h6>Click here to upload an image.</h6>
                      </div>
                      <material-input
                        style="display: none"
                        type="file"
                        id="image_login_bg"
                        @change="handleFileUploadLoginBg($event)"
                        accept="image/png,image/jpeg,image/webp"
                      />
                      <div class="upload-size-hint">
                        {{ $t('Recommended_Size_Landing_Page') }} · {{ $t('Member_Login_Background_Format') }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            
            <!-- SF307: header picture of the physical-branch outlet list. -->
            <div id="slide_list" v-if="type == 4">
              <div class="row mt-3">
                <div class="col-lg-9 col-12 color-common d-flex align-items-center">
                  <h3 class="title-page mb-0 pe-2">{{ $t('Outlet_List_Header') }}</h3>
                </div>
                <div class="col-lg-3 col-12 d-flex justify-content-end">
                  <material-button @click="saveOutletListHeader()" class="btn-background btn-sm">
                    Save
                  </material-button>
                </div>
              </div>
              <div class="row row-flex">
                <div class="col-xl-4 col-lg-6 col-12">
                  <div class="slide-box login-bg-box">
                    <div class="text-title">{{ $t('Outlet_List_Header_Hint') }}</div>
                    <div class="w-100 p-3">
                      <div class="dowload-img portrait-34" v-show="outletHeaderPreview || outletHeader">
                        <div class="w-100 h-100" style="position: relative">
                          <img
                            class="image-url portrait-34 login-bg-img"
                            v-if="outletHeaderPreview || outletHeader"
                            :src="outletHeaderPreview || outletHeader"
                          />
                          <i
                            class="fa fa-times icon-close-sidenav-main danger"
                            style="
                              position: absolute;
                              color: #f44335;
                              font-size: 20px;
                              right: 5px;
                              top: 8px;
                            "
                            aria-hidden="true"
                            @click="clearOutletHeader()"
                          ></i>
                          <div class="btn-edit-img">
                            <i
                              class="fas fa-pencil-alt text-dark"
                              aria-hidden="true"
                              @click="uploadOutletHeader()"
                            ></i>
                          </div>
                        </div>
                      </div>
                      <div
                        class="dowload-img portrait-34"
                        @click="uploadOutletHeader()"
                        v-show="!outletHeaderPreview && !outletHeader"
                      >
                        <i class="material-icons css-icon-upload mt-0">backup</i>
                        <h6>Click here to upload an image.</h6>
                      </div>
                      <material-input
                        style="display: none"
                        type="file"
                        id="image_outlet_header"
                        @change="handleFileUploadOutletHeader($event)"
                        accept="image/png,image/jpeg,image/webp"
                      />
                      <div class="upload-size-hint">
                        {{ $t('Recommended_Size_Outlet_List_Header') }} · {{ $t('Member_Login_Background_Format') }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div id="slide_list" v-if="type == 2">
              <div class="row mt-3">
                <div class="col-lg-12 col-12 color-common d-flex align-items-center">
                  <div class="col-2">
                    <h3 class="title-page mb-0 pe-2">Select branch</h3>
                  </div>
                  <div class="col-3">
                    <Multiselect
                      :options="branches"
                      :canClear="false"
                      v-model="branchIdSelect"
                      @change="changeBranches"
                    />
                  </div>
                </div>
              </div>
              <div>
                <div class="row mt-3">
                  <div class="col-lg-9 col-12 color-common d-flex align-items-center">
                    <h3 class="title-page mb-0 pe-2">Homepage Slider</h3>
                    <div>(Maximum 9 slides display on page at a time)</div>
                  </div>
                  <div class="col-lg-3 col-12 d-flex justify-content-end">
                    <div style="margin-right: 10px;" v-if="this.slidesOrderingHomepage.length < 9">
                      <a
                        @click="addRowSlideOrderingHomePage()"
                        class="text-decoration-underline tag-a-custom"
                        >Add Image</a
                      >
                    </div>
                    <material-button @click="saveSlideOrderingHomePage()" class="btn-background btn-sm">
                      Save
                    </material-button>
                  </div>
                </div>
                <draggable 
                    v-model="slidesOrderingHomepage" 
                    group="slides" 
                    @start="drag=true" 
                    @end="onEndDragSlideOrderingHomepage"
                    item-key="id"
                    class="row row-flex"
                  >
                  <template #item="{element, index}">
                    <div class="col-xl-4 col-lg-6 col-12">
                    <div class="slide-box" :class="{'slide-scheduled': !element.active}">
                      <div class="d-flex justify-content-between">
                        <div class="ps-0 text-title">
                          {{ $t('Image_Sequence') }}
                        </div>
                        <i
                          style="color: #f44335; font-size: 20px; cursor: pointer;"
                          class="fa fa-times icon-close-sidenav-main danger"
                          aria-hidden="true"
                          @click="removeRowSlideOrderingHomepage(index)"
                        ></i>
                      </div>
                      <div class="w-100 p-3">
                        <div class="dowload-img" v-show="urlImagePreviewOrderingHomepage[index] || element.file_name">
                          <div id="preview" class="w-100" style="position: relative">
                            <img
                              class="image-url"
                              v-if="urlImagePreviewOrderingHomepage[index] || element.file_name"
                              :src="urlImagePreviewOrderingHomepage[index] ? urlImagePreviewOrderingHomepage[index] : element.file_name"
                            />
                            <i
                              class="fa fa-times icon-close-sidenav-main danger"
                              v-if="urlImagePreviewOrderingHomepage[index] || element.file_name"
                              style="
                                position: absolute;
                                color: #f44335;
                                font-size: 20px;
                                right: 5px;
                                top: 8px;
                              "
                              aria-hidden="true"
                              @click="clearImageOrderingHomepage(index)"
                            ></i>
                            <div class="btn-edit-img">
                              <i
                                class="fas fa-pencil-alt text-dark"
                                v-if="urlImagePreviewOrderingHomepage[index] || element.file_name"
                                aria-hidden="true"
                                @click="uploadFileOrderingHomepage(index)"
                              ></i>
                            </div>
                            <div class="schedule-tag" v-if="!element.active">SCHEDULED</div>
                          </div>
                        </div>
                        <div
                          class="dowload-img"
                          @click="uploadFileOrderingHomepage(index)"
                          v-show="!urlImagePreviewOrderingHomepage[index] && !element.file_name"
                        >
                          <material-input
                            style="display: none"
                            type="file"
                            :id="`image_ordering_homepage_${index}`"
                            @change="handleFileUploadOrderingHomepage($event, index)"
                            accept="image/*"
                          />
                          <i class="material-icons css-icon-upload mt-0">backup</i>
                          <h6>Click here to upload an image.</h6>
                        </div>
                        <div class="upload-size-hint">{{ $t('Recommended_Size_Banner') }}</div>
                        <div
                          class="is-invalid d-flex align-items-center pe-2"
                          v-if="fieldRequired.isImageRequire"
                        >
                          {{ messageImageErrorOrderingHomepage }}
                        </div>
                      </div>
                      <div class="slide-config">
                        <div>
                          <div class="ps-0 label-form mb-2">
                            {{ $t('Who_can_see_this_slide') }}
                          </div>
                          <Multiselect
                            v-model="element.slide_tiers"
                            mode="tags"
                            :close-on-select="false"
                            class="multiselect-slide"
                            :searchable="true"
                            :options="tiers"
                            placeholder="Select tiers can see"
                            :canClear="false"
                          />  
                        </div>
                        <div class="mt-3">
                          <div class="ps-0 label-form mb-2">
                            {{ $t('Display_Period') }}
                          </div>
                          <div class="d-flex align-items-center">
                            <div class="label-form pe-3 min-w-50px">{{ $t('From') }}</div>
                              <Datepicker
                                v-model="element.start_date"
                                :enableTimePicker="false"
                                class="date-time pe-3"
                                :disabled="alwaysDisplayCheckedOrderingHomepage[index] == 'true' ? true : false"
                                :format="format"
                              />
                              <Datepicker
                                v-model="element.start_time"
                                timePicker
                                class="date-time"
                                :disabled="alwaysDisplayCheckedOrderingHomepage[index] == 'true' ? true : false"
                              />
                          </div>
                          <div class="d-flex mt-2 align-items-center">
                            <div class="label-form pe-3 min-w-50px">{{ $t('To') }}</div>
                              <Datepicker
                                v-model="element.end_date"
                                :enableTimePicker="false"
                                class="date-time pe-3"
                                :disabled="alwaysDisplayCheckedOrderingHomepage[index] == 'true' ? true : false"
                                :format="format"
                              />
                              <Datepicker
                                v-model="element.end_time"
                                timePicker
                                class="date-time"
                                :disabled="alwaysDisplayCheckedOrderingHomepage[index] == 'true' ? true : false"
                              />
                          </div>
                          <div class="d-flex mt-2" v-if="fieldRequiredOrderingHomepage[index].isDateRequire">
                            <div class="min-w-50px"></div>
                            <span
                              class="is-invalid"
                              >{{ textRequiredDateCustomOrderingHomepage[index] }}</span
                            >
                          </div>
                          <div class="d-flex mt-2">
                            <div class="min-w-50px"></div>
                            <material-checkbox
                              v-model="element.always_display"
                              :checked="element.always_display ? true : false"
                              :id="`always_display_${index}`"
                              class="align-items-center checkbox-custom"
                              @change="checkOrderingHomepage($event, index)"
                            >
                              <template v-slot:label>
                                {{ $t('Always_Display') }}
                              </template>
                            </material-checkbox>
                          </div>
                        </div>
                        <!-- <div class="mt-3">
                          <div class="ps-0 label-form mb-2">
                            {{ $t('Destination_link') }}
                          </div>
                          <material-input
                            class="textarea-slide"
                            v-model="element.destination_link"
                            placeholder="Enter destination link"
                          />
                          <span
                            class="is-invalid"
                            v-if="fieldRequiredOrderingHomepage[index].invalidLink"
                            >Invalid link.</span
                          >
                        </div> -->
                      </div>
                    </div>
                  </div>
                  </template>
                </draggable>
              </div>
              <div style="text-align: center;font-style: italic;">Drag to change image position</div>
              <hr />
              <div>
                <div class="row mt-3">
                  <div class="col-lg-9 col-12 color-common d-flex align-items-center">
                    <h3 class="title-page mb-0 pe-2">Customization Page Header</h3>
                    <div>(Maximum 9 slides display on page at a time)</div>
                  </div>
                  <div class="col-lg-3 col-12 d-flex justify-content-end">
                    <div style="margin-right: 10px;" v-if="this.slidesOrderingCustompage.length < 9">
                      <a
                        @click="addRowSlideOrderingCustomPage()"
                        class="text-decoration-underline tag-a-custom"
                        >Add Image</a
                      >
                    </div>
                    <material-button @click="saveSlideOrderingCustomPage()" class="btn-background btn-sm">
                      Save
                    </material-button>
                  </div>
                </div>
                <draggable 
                    v-model="slidesOrderingCustompage" 
                    group="slides" 
                    @start="drag=true" 
                    @end="onEndDragSlideOrderingCustompage"
                    item-key="id"
                    class="row row-flex"
                  >
                  <template #item="{element, index}">
                    <div class="col-xl-4 col-lg-6 col-12">
                    <div class="slide-box" :class="{'slide-scheduled': !element.active}">
                      <div class="d-flex justify-content-between">
                        <div class="ps-0 text-title">
                          {{ $t('Image_Sequence') }}
                        </div>
                        <i
                          style="color: #f44335; font-size: 20px; cursor: pointer;"
                          class="fa fa-times icon-close-sidenav-main danger"
                          aria-hidden="true"
                          @click="removeRowSlideOrderingCustompage(index)"
                        ></i>
                      </div>
                      <div class="w-100 p-3">
                        <div class="dowload-img" v-show="urlImagePreviewOrderingCustompage[index] || element.file_name">
                          <div id="preview" class="w-100" style="position: relative">
                            <img
                              class="image-url"
                              v-if="urlImagePreviewOrderingCustompage[index] || element.file_name"
                              :src="urlImagePreviewOrderingCustompage[index] ? urlImagePreviewOrderingCustompage[index] : element.file_name"
                            />
                            <i
                              class="fa fa-times icon-close-sidenav-main danger"
                              v-if="urlImagePreviewOrderingCustompage[index] || element.file_name"
                              style="
                                position: absolute;
                                color: #f44335;
                                font-size: 20px;
                                right: 5px;
                                top: 8px;
                              "
                              aria-hidden="true"
                              @click="clearImageOrderingCustompage(index)"
                            ></i>
                            <div class="btn-edit-img">
                              <i
                                class="fas fa-pencil-alt text-dark"
                                v-if="urlImagePreviewOrderingCustompage[index] || element.file_name"
                                aria-hidden="true"
                                @click="uploadFileOrderingCustompage(index)"
                              ></i>
                            </div>
                            <div class="schedule-tag" v-if="!element.active">SCHEDULED</div>
                          </div>
                        </div>
                        <div
                          class="dowload-img"
                          @click="uploadFileOrderingCustompage(index)"
                          v-show="!urlImagePreviewOrderingCustompage[index] && !element.file_name"
                        >
                          <material-input
                            style="display: none"
                            type="file"
                            :id="`image_ordering_custompage_${index}`"
                            @change="handleFileUploadOrderingCustompage($event, index)"
                            accept="image/*"
                          />
                          <i class="material-icons css-icon-upload mt-0">backup</i>
                          <h6>Click here to upload an image.</h6>
                        </div>
                        <div class="upload-size-hint">{{ $t('Recommended_Size_Banner') }}</div>
                        <div
                          class="is-invalid d-flex align-items-center pe-2"
                          v-if="fieldRequiredOrderingCustompage.isImageRequire"
                        >
                          {{ messageImageErrorOrderingCustompage }}
                        </div>
                      </div>
                      <div class="slide-config">
                        <div>
                          <div class="ps-0 label-form mb-2">
                            {{ $t('Who_can_see_this_slide') }}
                          </div>
                          <Multiselect
                            v-model="element.slide_tiers"
                            mode="tags"
                            :close-on-select="false"
                            class="multiselect-slide"
                            :searchable="true"
                            :options="tiers"
                            placeholder="Select tiers can see"
                            :canClear="false"
                          />  
                        </div>
                        <div class="mt-3">
                          <div class="ps-0 label-form mb-2">
                            Display Condition
                          </div>
                          <div style="display: inline-flex;align-items: center;width: 100%;">
                            <div style="display: inline-flex;gap: 5px;width: 50%;">
                              <input type="radio" value="1" v-model="element.display_condition" />
                              <div class="label-form">If items have tag</div>
                            </div>
                            <material-input
                              v-model="element.tags"
                              style="width: 50%;"
                              class="textarea-slide"
                              placeholder="Enter tag"
                            /> 
                          </div>
                          <div style="display: inline-flex;justify-content: space-between;align-items: center;gap: 10px">
                            <div style="display: inline-flex;gap: 5px">
                              <input type="radio" value="2" v-model="element.display_condition" />
                              <div class="label-form">Suggested Adds On</div>
                            </div>
                          </div>
                        </div>
                        <div class="mt-3">
                          <div class="ps-0 label-form mb-2">
                            {{ $t('Display_Period') }}
                          </div>
                          <div class="d-flex align-items-center">
                            <div class="label-form pe-3 min-w-50px">{{ $t('From') }}</div>
                              <Datepicker
                                v-model="element.start_date"
                                :enableTimePicker="false"
                                class="date-time pe-3"
                                :disabled="alwaysDisplayCheckedOrderingCustompage[index] == 'true' ? true : false"
                                :format="format"
                              />
                              <Datepicker
                                v-model="element.start_time"
                                timePicker
                                class="date-time"
                                :disabled="alwaysDisplayCheckedOrderingCustompage[index] == 'true' ? true : false"
                              />
                          </div>
                          <div class="d-flex mt-2 align-items-center">
                            <div class="label-form pe-3 min-w-50px">{{ $t('To') }}</div>
                              <Datepicker
                                v-model="element.end_date"
                                :enableTimePicker="false"
                                class="date-time pe-3"
                                :disabled="alwaysDisplayCheckedOrderingCustompage[index] == 'true' ? true : false"
                                :format="format"
                              />
                              <Datepicker
                                v-model="element.end_time"
                                timePicker
                                class="date-time"
                                :disabled="alwaysDisplayCheckedOrderingCustompage[index] == 'true' ? true : false"
                              />
                          </div>
                          <div class="d-flex mt-2" v-if="fieldRequiredOrderingCustompage[index].isDateRequire">
                            <div class="min-w-50px"></div>
                            <span
                              class="is-invalid"
                              >{{ textRequiredDateCustomOrderingCustompage[index] }}</span
                            >
                          </div>
                          <div class="d-flex mt-2">
                            <div class="min-w-50px"></div>
                            <material-checkbox
                              v-model="element.always_display"
                              :checked="element.always_display ? true : false"
                              :id="`always_display_${index}`"
                              class="align-items-center checkbox-custom"
                              @change="checkOrderingCustompage($event, index)"
                            >
                              <template v-slot:label>
                                {{ $t('Always_Display') }}
                              </template>
                            </material-checkbox>
                          </div>
                        </div>
                        <div class="mt-3">
                          <div class="ps-0 label-form mb-2">
                            Clickable function
                          </div>
                          <div>
                            <div style="display: inline-flex;align-items: center;width: 100%;">
                              <div style="display: inline-flex;gap: 5px;width: 50%;">
                                <input type="radio" value="1" v-model="element.clickablefunction" :checked="element.destination_link != '' && element.direct_to_menu_item == null && element.direct_to_suggested_adds_on == null" />
                                <div class="label-form">Destination link</div>
                              </div>
                              <material-input
                                v-model="element.destination_link"
                                style="
                                    width: 50%;
                                "
                                class="textarea-slide"
                                placeholder="Enter link"
                              />
                            </div>
                            <span
                              class="is-invalid"
                              v-if="fieldRequiredOrderingCustompage[index].invalidLink"
                              >Invalid link.</span
                            >
                          </div>
                          <div style="display: inline-flex;align-items: center;width: 100%;">
                            <div style="display: inline-flex;gap: 5px;width: 50%;">
                              <input type="radio" value="2" v-model="element.clickablefunction" :checked="element.direct_to_menu_item != null" />
                              <div class="label-form">Direct to a certain Menu Item</div>
                            </div>
                            <Multiselect
                              v-model="element.direct_to_menu_item"
                              style="
                                  width: 50%;
                              "
                              class="multiselect-slide"
                              :searchable="true"
                              :options="items"
                              placeholder="Select"
                              :canClear="false"
                            />  
                          </div>
                          <div style="display: inline-flex;justify-content: space-between;align-items: center;gap: 10px">
                            <div style="display: inline-flex;gap: 5px">
                              <input type="radio" value="3" v-model="element.clickablefunction" :disabled="element.display_condition == '1' ? true : false" :checked="element.direct_to_suggested_adds_on != null" />
                              <div class="label-form">Direct to suggested Adds On</div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  </template>
                </draggable>
              </div>
              <div style="text-align: center;font-style: italic;">Drag to change image position</div>
              <hr />
              <div>
                <div class="row mt-3">
                  <div class="col-lg-9 col-12 color-common d-flex align-items-center">
                    <h3 class="title-page mb-0 pe-2">Checkout Page Banner</h3>
                    <div>(Maximum 9 slides display on page at a time)</div>
                  </div>
                  <div class="col-lg-3 col-12 d-flex justify-content-end">
                    <div style="margin-right: 10px;" v-if="this.slidesOrderingCheckoutpage.length < 9">
                      <a
                        @click="addRowSlideOrderingCheckoutPage()"
                        class="text-decoration-underline tag-a-custom"
                        >Add Image</a
                      >
                    </div>
                    <material-button @click="saveSlideOrderingCheckoutPage()" class="btn-background btn-sm">
                      Save
                    </material-button>
                  </div>
                </div>
                <draggable 
                    v-model="slidesOrderingCheckoutpage" 
                    group="slides" 
                    @start="drag=true" 
                    @end="onEndDragSlideOrderingCheckoutpage"
                    item-key="id"
                    class="row row-flex"
                  >
                  <template #item="{element, index}">
                    <div class="col-xl-4 col-lg-6 col-12">
                    <div class="slide-box" :class="{'slide-scheduled': !element.active}">
                      <div class="d-flex justify-content-between">
                        <div class="ps-0 text-title">
                          {{ $t('Image_Sequence') }}
                        </div>
                        <i
                          style="color: #f44335; font-size: 20px; cursor: pointer;"
                          class="fa fa-times icon-close-sidenav-main danger"
                          aria-hidden="true"
                          @click="removeRowSlideOrderingCheckoutpage(index)"
                        ></i>
                      </div>
                      <div class="w-100 p-3">
                        <div class="dowload-img" v-show="urlImagePreviewOrderingCheckoutpage[index] || element.file_name">
                          <div id="preview" class="w-100" style="position: relative">
                            <img
                              class="image-url"
                              v-if="urlImagePreviewOrderingCheckoutpage[index] || element.file_name"
                              :src="urlImagePreviewOrderingCheckoutpage[index] ? urlImagePreviewOrderingCheckoutpage[index] : element.file_name"
                            />
                            <i
                              class="fa fa-times icon-close-sidenav-main danger"
                              v-if="urlImagePreviewOrderingCheckoutpage[index] || element.file_name"
                              style="
                                position: absolute;
                                color: #f44335;
                                font-size: 20px;
                                right: 5px;
                                top: 8px;
                              "
                              aria-hidden="true"
                              @click="clearImageOrderingCheckoutpage(index)"
                            ></i>
                            <div class="btn-edit-img">
                              <i
                                class="fas fa-pencil-alt text-dark"
                                v-if="urlImagePreviewOrderingCheckoutpage[index] || element.file_name"
                                aria-hidden="true"
                                @click="uploadFileOrderingCheckoutpage(index)"
                              ></i>
                            </div>
                            <div class="schedule-tag" v-if="!element.active">SCHEDULED</div>
                          </div>
                        </div>
                        <div
                          class="dowload-img"
                          @click="uploadFileOrderingCheckoutpage(index)"
                          v-show="!urlImagePreviewOrderingCheckoutpage[index] && !element.file_name"
                        >
                          <material-input
                            style="display: none"
                            type="file"
                            :id="`image_ordering_checkoutpage_${index}`"
                            @change="handleFileUploadOrderingCheckoutpage($event, index)"
                            accept="image/*"
                          />
                          <i class="material-icons css-icon-upload mt-0">backup</i>
                          <h6>Click here to upload an image.</h6>
                        </div>
                        <div class="upload-size-hint">{{ $t('Recommended_Size_Banner') }}</div>
                        <div
                          class="is-invalid d-flex align-items-center pe-2"
                          v-if="fieldRequiredOrderingCheckoutpage.isImageRequire"
                        >
                          {{ messageImageErrorOrderingCheckoutpage }}
                        </div>
                      </div>
                      <div class="slide-config">
                        <div>
                          <div class="ps-0 label-form mb-2">
                            {{ $t('Who_can_see_this_slide') }}
                          </div>
                          <Multiselect
                            v-model="element.slide_tiers"
                            mode="tags"
                            :close-on-select="false"
                            class="multiselect-slide"
                            :searchable="true"
                            :options="tiers"
                            placeholder="Select tiers can see"
                            :canClear="false"
                          />  
                        </div>
                        <div class="mt-3">
                          <div class="ps-0 label-form mb-2">
                            Display Condition
                          </div>
                          <div style="display: inline-flex;align-items: center;width: 100%;">
                            <div style="display: inline-flex;gap: 5px;width: 50%;">
                              <input type="radio" value="1" v-model="element.display_condition" />
                              <div class="label-form">If items have tag</div>
                            </div>
                            <material-input
                              v-model="element.tags"
                              style="width: 50%;"
                              class="textarea-slide"
                              placeholder="Enter tag"
                            /> 
                          </div>
                          <div style="display: inline-flex;justify-content: space-between;align-items: center;gap: 10px">
                            <div style="display: inline-flex;gap: 5px">
                              <input type="radio" value="2" v-model="element.display_condition" />
                              <div class="label-form">Suggested Adds On</div>
                            </div>
                          </div>
                        </div>
                        <div class="mt-3">
                          <div class="ps-0 label-form mb-2">
                            {{ $t('Display_Period') }}
                          </div>
                          <div class="d-flex align-items-center">
                            <div class="label-form pe-3 min-w-50px">{{ $t('From') }}</div>
                              <Datepicker
                                v-model="element.start_date"
                                :enableTimePicker="false"
                                class="date-time pe-3"
                                :disabled="alwaysDisplayCheckedOrderingCheckoutpage[index] == 'true' ? true : false"
                                :format="format"
                              />
                              <Datepicker
                                v-model="element.start_time"
                                timePicker
                                class="date-time"
                                :disabled="alwaysDisplayCheckedOrderingCheckoutpage[index] == 'true' ? true : false"
                              />
                          </div>
                          <div class="d-flex mt-2 align-items-center">
                            <div class="label-form pe-3 min-w-50px">{{ $t('To') }}</div>
                              <Datepicker
                                v-model="element.end_date"
                                :enableTimePicker="false"
                                class="date-time pe-3"
                                :disabled="alwaysDisplayCheckedOrderingCheckoutpage[index] == 'true' ? true : false"
                                :format="format"
                              />
                              <Datepicker
                                v-model="element.end_time"
                                timePicker
                                class="date-time"
                                :disabled="alwaysDisplayCheckedOrderingCheckoutpage[index] == 'true' ? true : false"
                              />
                          </div>
                          <div class="d-flex mt-2" v-if="fieldRequiredOrderingCheckoutpage[index].isDateRequire">
                            <div class="min-w-50px"></div>
                            <span
                              class="is-invalid"
                              >{{ textRequiredDateCustomOrderingCheckoutpage[index] }}</span
                            >
                          </div>
                          <div class="d-flex mt-2">
                            <div class="min-w-50px"></div>
                            <material-checkbox
                              v-model="element.always_display"
                              :checked="element.always_display ? true : false"
                              :id="`always_display_${index}`"
                              class="align-items-center checkbox-custom"
                              @change="checkOrderingCheckoutpage($event, index)"
                            >
                              <template v-slot:label>
                                {{ $t('Always_Display') }}
                              </template>
                            </material-checkbox>
                          </div>
                        </div>
                        <div class="mt-3">
                          <div class="ps-0 label-form mb-2">
                            Clickable function
                          </div>
                          <div>
                            <div style="display: inline-flex;align-items: center;width: 100%;">
                              <div style="display: inline-flex;gap: 5px;width: 50%;">
                                <input type="radio" value="1" v-model="element.clickablefunction" :checked="element.destination_link != '' && element.direct_to_menu_item == null && element.direct_to_suggested_adds_on == null" />
                                <div class="label-form">Destination link</div>
                              </div>
                              <material-input
                                v-model="element.destination_link"
                                style="
                                    width: 50%;
                                "
                                class="textarea-slide"
                                placeholder="Enter link"
                              /> 
                            </div>
                            <span
                              class="is-invalid"
                              v-if="fieldRequiredOrderingCheckoutpage[index].invalidLink"
                              >Invalid link.</span
                            >
                          </div>
                          <div style="display: inline-flex;align-items: center;width: 100%;">
                            <div style="display: inline-flex;gap: 5px;width: 50%;">
                              <input type="radio" value="2" v-model="element.clickablefunction" :checked="element.direct_to_menu_item != null" />
                              <div class="label-form">Direct to a certain Menu Item</div>
                            </div>
                            <Multiselect
                              v-model="element.direct_to_menu_item"
                              style="
                                  width: 50%;
                              "
                              class="multiselect-slide"
                              :searchable="true"
                              :options="items"
                              placeholder="Select"
                              :canClear="false"
                            />  
                          </div>
                          <div style="display: inline-flex;justify-content: space-between;align-items: center;gap: 10px">
                            <div style="display: inline-flex;gap: 5px">
                              <input type="radio" value="3" v-model="element.clickablefunction" :disabled="element.display_condition == '1' ? true : false" :checked="element.direct_to_suggested_adds_on != null" />
                              <div class="label-form">Direct to suggested Adds On</div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  </template>
                </draggable>
              </div>
              <div style="text-align: center;font-style: italic;">Drag to change image position</div>
              <hr />
              <div>
                <div class="row mt-3">
                  <div class="col-lg-9 col-12 color-common d-flex align-items-center">
                    <h3 class="title-page mb-0 pe-2">Landing Page Sliding Banner</h3>
                    <div>(Maximum 9 slides display on page at a time)</div>
                  </div>
                  <div class="col-lg-3 col-12 d-flex justify-content-end">
                    <div style="margin-right: 10px;" v-if="this.slidesOrderingLandingPage.length < 9">
                      <a
                        @click="addRowSlideOrderingLandingPage()"
                        class="text-decoration-underline tag-a-custom"
                        >Add Image</a
                      >
                    </div>
                    <material-button @click="saveSlideOrderingLandingPage()" class="btn-background btn-sm">
                      Save
                    </material-button>
                  </div>
                </div>
                <draggable 
                    v-model="slidesOrderingLandingPage" 
                    group="slides" 
                    item-key="id"
                    class="row row-flex"
                    :disabled="true"
                  >
                  <template #item="{element, index}">
                    <div class="col-xl-4 col-lg-6 col-12">
                    <div class="slide-box" :class="{'slide-scheduled': !element.active}">
                      <div class="d-flex justify-content-between">
                        <div class="ps-0 text-title">
                          {{ $t('Image_Sequence') }}
                        </div>
                        <i
                          style="color: #f44335; font-size: 20px; cursor: pointer;"
                          class="fa fa-times icon-close-sidenav-main danger"
                          aria-hidden="true"
                          @click="removeRowSlideOrderingLandingPage(index)"
                        ></i>
                      </div>
                      <div class="d-flex justify-content-between" style="align-items: center;justify-content: center !important;margin-top: 10px" v-if="element.id">
                        <div style="display: flex;width: 90px;justify-content: space-between;">
                          <div>
                            <i
                              style="font-size: 20px;cursor: pointer;color: black !important;border: 1px solid black;padding: 5px;"
                              class="fa fa-arrow-left icon-close-sidenav-main"
                              aria-hidden="true"
                              @click="handleBackPosition(index)"
                            ></i>
                          </div>
                          <div style="padding: 5px">{{ element.ordering }}</div>
                          <div>
                            <i
                              style="font-size: 20px;cursor: pointer;color: black !important;border: 1px solid black;padding: 5px;"
                              class="fa fa-arrow-right icon-close-sidenav-main"
                              aria-hidden="true"
                              @click="handleNextPosition(index)"
                            ></i>
                          </div>
                        </div>
                      </div>
                      <div class="w-100 p-3">
                        <div class="dowload-img portrait-45" v-show="urlImagePreviewOrderingLandingPage[index] || element.file_name">
                          <div id="preview" class="w-100" style="position: relative">
                            <img
                              class="image-url portrait-45"
                              v-if="urlImagePreviewOrderingLandingPage[index] || element.file_name"
                              :src="urlImagePreviewOrderingLandingPage[index] ? urlImagePreviewOrderingLandingPage[index] : element.file_name"
                            />
                            <i
                              class="fa fa-times icon-close-sidenav-main danger"
                              v-if="urlImagePreviewOrderingLandingPage[index] || element.file_name"
                              style="
                                position: absolute;
                                color: #f44335;
                                font-size: 20px;
                                right: 5px;
                                top: 8px;
                              "
                              aria-hidden="true"
                              @click="clearImageOrderingLandingPage(index)"
                            ></i>
                            <div class="btn-edit-img">
                              <i
                                class="fas fa-pencil-alt text-dark"
                                v-if="urlImagePreviewOrderingLandingPage[index] || element.file_name"
                                aria-hidden="true"
                                @click="uploadFileOrderingLandingPage(index)"
                              ></i>
                            </div>
                            <!-- <div class="schedule-tag" v-if="!element.active">SCHEDULED</div> -->
                          </div>
                        </div>
                        <div
                          class="dowload-img portrait-45"
                          @click="uploadFileOrderingLandingPage(index)"
                          v-show="!urlImagePreviewOrderingLandingPage[index] && !element.file_name"
                        >
                          <material-input
                            style="display: none"
                            type="file"
                            :id="`image_ordering_landing_page_${index}`"
                            @change="handleFileUploadOrderingLandingPage($event, index)"
                            accept="image/*"
                          />
                          <i class="material-icons css-icon-upload mt-0">backup</i>
                          <h6>Click here to upload an image.</h6>
                        </div>
                        <div class="upload-size-hint">{{ $t('Recommended_Size_Landing_Page') }}</div>
                        <div
                          class="is-invalid d-flex align-items-center pe-2"
                          v-if="fieldRequiredOrderingLandingPage.isImageRequire"
                        >
                          {{ messageImageErrorOrderingLandingPage }}
                        </div>
                      </div>
                      <div class="slide-config">
                        <!-- <div>
                          <div class="ps-0 label-form mb-2">
                            {{ $t('Who_can_see_this_slide') }}
                          </div>
                          <Multiselect
                            v-model="element.slide_tiers"
                            mode="tags"
                            :close-on-select="false"
                            class="multiselect-slide"
                            :searchable="true"
                            :options="tiers"
                            placeholder="Select tiers can see"
                            :canClear="false"
                          />  
                        </div> -->
                        <!-- <div class="mt-3">
                          <div class="ps-0 label-form mb-2">
                            Display Condition
                          </div>
                          <div style="display: inline-flex;align-items: center;width: 100%;">
                            <div style="display: inline-flex;gap: 5px;width: 50%;">
                              <input type="radio" value="1" v-model="element.display_condition" />
                              <div class="label-form">If items have tag</div>
                            </div>
                            <material-input
                              v-model="element.tags"
                              style="width: 50%;"
                              class="textarea-slide"
                              placeholder="Enter tag"
                            /> 
                          </div>
                          <div style="display: inline-flex;justify-content: space-between;align-items: center;gap: 10px">
                            <div style="display: inline-flex;gap: 5px">
                              <input type="radio" value="2" v-model="element.display_condition" />
                              <div class="label-form">Suggested Adds On</div>
                            </div>
                          </div>
                        </div> -->
                        <div class="mt-3">
                          <div class="ps-0 label-form mb-2">
                            {{ $t('Display_Period') }}
                          </div>
                          <div class="d-flex align-items-center">
                            <div class="label-form pe-3 min-w-50px">{{ $t('From') }}</div>
                              <Datepicker
                                v-model="element.start_date"
                                :enableTimePicker="false"
                                class="date-time pe-3"
                                :disabled="alwaysDisplayCheckedOrderingLandingPage[index] == 'true' ? true : false"
                                :format="format"
                              />
                              <Datepicker
                                v-model="element.start_time"
                                timePicker
                                class="date-time"
                                :disabled="alwaysDisplayCheckedOrderingLandingPage[index] == 'true' ? true : false"
                              />
                          </div>
                          <div class="d-flex mt-2 align-items-center">
                            <div class="label-form pe-3 min-w-50px">{{ $t('To') }}</div>
                              <Datepicker
                                v-model="element.end_date"
                                :enableTimePicker="false"
                                class="date-time pe-3"
                                :disabled="alwaysDisplayCheckedOrderingLandingPage[index] == 'true' ? true : false"
                                :format="format"
                              />
                              <Datepicker
                                v-model="element.end_time"
                                timePicker
                                class="date-time"
                                :disabled="alwaysDisplayCheckedOrderingLandingPage[index] == 'true' ? true : false"
                              />
                          </div>
                          <div class="d-flex mt-2" v-if="fieldRequiredOrderingLandingPage[index].isDateRequire">
                            <div class="min-w-50px"></div>
                            <span
                              class="is-invalid"
                              >{{ textRequiredDateCustomOrderingLandingPage[index] }}</span
                            >
                          </div>
                          <div class="d-flex mt-2">
                            <div class="min-w-50px"></div>
                            <material-checkbox
                              v-model="element.always_display"
                              :checked="element.always_display ? true : false"
                              :id="`always_display_${index}`"
                              class="align-items-center checkbox-custom"
                              @change="checkOrderingLandingPage($event, index)"
                            >
                              <template v-slot:label>
                                {{ $t('Always_Display') }}
                              </template>
                            </material-checkbox>
                          </div>
                        </div>
                        <!-- <div class="mt-3">
                          <div class="ps-0 label-form mb-2">
                            Clickable function
                          </div>
                          <div style="display: inline-flex;align-items: center;width: 100%;">
                            <div style="display: inline-flex;gap: 5px;width: 50%;">
                              <input type="radio" value="1" v-model="element.clickablefunction" :checked="element.destination_link != '' && element.direct_to_menu_item == null && element.direct_to_suggested_adds_on == null" />
                              <div class="label-form">Destination link</div>
                            </div>
                            <material-input
                              v-model="element.destination_link"
                              style="
                                  width: 50%;
                              "
                              class="textarea-slide"
                              placeholder="Enter link"
                            /> 
                          </div>
                          <div style="display: inline-flex;align-items: center;width: 100%;">
                            <div style="display: inline-flex;gap: 5px;width: 50%;">
                              <input type="radio" value="2" v-model="element.clickablefunction" :checked="element.direct_to_menu_item != null" />
                              <div class="label-form">Direct to a certain Menu Item</div>
                            </div>
                            <Multiselect
                              v-model="element.direct_to_menu_item"
                              style="
                                  width: 50%;
                              "
                              class="multiselect-slide"
                              :searchable="true"
                              :options="items"
                              placeholder="Select"
                              :canClear="false"
                            />  
                          </div>
                          <div style="display: inline-flex;justify-content: space-between;align-items: center;gap: 10px">
                            <div style="display: inline-flex;gap: 5px">
                              <input type="radio" value="3" v-model="element.clickablefunction" :disabled="element.display_condition == '1' ? true : false" :checked="element.direct_to_suggested_adds_on != null" />
                              <div class="label-form">Direct to suggested Adds On</div>
                            </div>
                          </div>
                        </div> -->
                      </div>
                    </div>
                  </div>
                  </template>
                </draggable>
              </div>
              <div style="text-align: center;font-style: italic;">Drag to change image position</div>
            </div>

            <div id="slide_list" v-if="type == 3">
              <div class="row mt-3">
                <div class="col-lg-12 col-12 color-common d-flex align-items-center">
                  <div class="col-2">
                    <h3 class="title-page mb-0 pe-2">Select branch</h3>
                  </div>
                  <div class="col-3">
                    <Multiselect
                      :options="branches"
                      :canClear="false"
                      v-model="branchIdSelect"
                      @change="changeBranches"
                    />
                  </div>
                </div>
              </div>
              <div>
                <div class="row mt-3">
                  <div class="col-lg-9 col-12 color-common d-flex align-items-center">
                    <h3 class="title-page mb-0 pe-2">Landing Page Slider</h3>
                    <div>(Maximum 3 slides display on page at a time - recommended: 1920 x 1080)</div>
                  </div>
                  <div class="col-lg-3 col-12 d-flex justify-content-end">
                    <div style="margin-right: 10px;" v-if="slidesKioskLandingpage.length < 3">
                      <a
                        @click="addRowSlideKioskLandingpage()"
                        class="text-decoration-underline tag-a-custom"
                        >Add Image</a
                      >
                    </div>
                    <material-button @click="saveSlideKioskLandingpage()" class="btn-background btn-sm">
                      Save
                    </material-button>
                  </div>
                </div>
                <draggable 
                    v-model="slidesKioskLandingpage" 
                    group="slides" 
                    @start="drag=true" 
                    @end="onEndDragSlideKioskLandingpage"
                    item-key="id"
                    class="row row-flex"
                  >
                  <template #item="{element, index}">
                    <div class="col-xl-4 col-lg-6 col-12">
                    <div class="slide-box" :class="{'slide-scheduled': !element.active}">
                      <div class="d-flex justify-content-between">
                        <div class="ps-0 text-title">
                          {{ $t('Image_Sequence') }}
                        </div>
                        <i
                          style="color: #f44335; font-size: 20px; cursor: pointer;"
                          class="fa fa-times icon-close-sidenav-main danger"
                          aria-hidden="true"
                          @click="removeRowSlideKioskLandingpage(index)"
                        ></i>
                      </div>
                      <div class="w-100 p-3">
                        <div class="dowload-img" v-show="urlImagePreviewKioskLandingpage[index] || element.file_name">
                          <div id="preview" class="w-100" style="position: relative">
                            <img
                              class="image-url landing"
                              v-if="urlImagePreviewKioskLandingpage[index] || element.file_name"
                              :src="urlImagePreviewKioskLandingpage[index] ? urlImagePreviewKioskLandingpage[index] : element.file_name"
                            />
                            <i
                              class="fa fa-times icon-close-sidenav-main danger"
                              v-if="urlImagePreviewKioskLandingpage[index] || element.file_name"
                              style="
                                position: absolute;
                                color: #f44335;
                                font-size: 20px;
                                right: 5px;
                                top: 8px;
                              "
                              aria-hidden="true"
                              @click="clearImageKioskLandingpage(index)"
                            ></i>
                            <div class="btn-edit-img">
                              <i
                                class="fas fa-pencil-alt text-dark"
                                v-if="urlImagePreviewKioskLandingpage[index] || element.file_name"
                                aria-hidden="true"
                                @click="uploadFileKioskLandingpage(index)"
                              ></i>
                            </div>
                            <div class="schedule-tag" v-if="!element.active">SCHEDULED</div>
                          </div>
                        </div>
                        <div
                          class="dowload-img landing"
                          @click="uploadFileKioskLandingpage(index)"
                          v-show="!urlImagePreviewKioskLandingpage[index] && !element.file_name"
                        >
                          <material-input
                            style="display: none"
                            type="file"
                            :id="`image_kiosk_landingpage_${index}`"
                            @change="handleFileUploadKioskLandingpage($event, index)"
                            accept="image/*"
                          />
                          <i class="material-icons css-icon-upload mt-0">backup</i>
                          <h6>Click here to upload an image.</h6>
                        </div>
                        <div
                          class="is-invalid d-flex align-items-center pe-2"
                          v-if="fieldRequired.isImageRequire"
                        >
                          {{ messageImageErrorKioskLandingpage }}
                        </div>
                      </div>
                      <div class="slide-config">
                        <div>
                          <div class="ps-0 label-form mb-2">
                            {{ $t('Who_can_see_this_slide') }}
                          </div>
                          <Multiselect
                            v-model="element.slide_tiers"
                            mode="tags"
                            :close-on-select="false"
                            class="multiselect-slide"
                            :searchable="true"
                            :options="tiers"
                            placeholder="Select tiers can see"
                            :canClear="false"
                          />  
                        </div>
                        <div class="mt-3">
                          <div class="ps-0 label-form mb-2">
                            {{ $t('Display_Period') }}
                          </div>
                          <div class="d-flex align-items-center">
                            <div class="label-form pe-3 min-w-50px">{{ $t('From') }}</div>
                              <Datepicker
                                v-model="element.start_date"
                                :enableTimePicker="false"
                                class="date-time pe-3"
                                :disabled="alwaysDisplayCheckedKioskLandingpage[index] == 'true' ? true : false"
                                :format="format"
                              />
                              <Datepicker
                                v-model="element.start_time"
                                timePicker
                                class="date-time"
                                :disabled="alwaysDisplayCheckedKioskLandingpage[index] == 'true' ? true : false"
                              />
                          </div>
                          <div class="d-flex mt-2 align-items-center">
                            <div class="label-form pe-3 min-w-50px">{{ $t('To') }}</div>
                              <Datepicker
                                v-model="element.end_date"
                                :enableTimePicker="false"
                                class="date-time pe-3"
                                :disabled="alwaysDisplayCheckedKioskLandingpage[index] == 'true' ? true : false"
                                :format="format"
                              />
                              <Datepicker
                                v-model="element.end_time"
                                timePicker
                                class="date-time"
                                :disabled="alwaysDisplayCheckedKioskLandingpage[index] == 'true' ? true : false"
                              />
                          </div>
                          <div class="d-flex mt-2" v-if="fieldRequiredKioskLandingpage[index].isDateRequire">
                            <div class="min-w-50px"></div>
                            <span
                              class="is-invalid"
                              >{{ textRequiredDateCustomKioskLandingpage[index] }}</span
                            >
                          </div>
                          <div class="d-flex mt-2">
                            <div class="min-w-50px"></div>
                            <material-checkbox
                              v-model="element.always_display"
                              :checked="element.always_display ? true : false"
                              :id="`always_display_${index}`"
                              class="align-items-center checkbox-custom"
                              @change="checkKioskLandingpage($event, index)"
                            >
                              <template v-slot:label>
                                {{ $t('Always_Display') }}
                              </template>
                            </material-checkbox>
                          </div>
                        </div>
                        <!-- <div class="mt-3">
                          <div class="ps-0 label-form mb-2">
                            {{ $t('Destination_link') }}
                          </div>
                          <material-input
                            class="textarea-slide"
                            v-model="element.destination_link"
                            placeholder="Enter destination link"
                          />
                          <span
                            class="is-invalid"
                            v-if="fieldRequiredOrderingHomepage[index].invalidLink"
                            >Invalid link.</span
                          >
                        </div> -->
                      </div>
                    </div>
                  </div>
                  </template>
                </draggable>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="position-fixed top-1 end-1 z-index-2 message-success">
        <material-snackbar
          v-if="snackbar === 'danger' || snackbar === 'success'"
          title=""
          date=""
          :description="message"
          :icon="{ component: 'campaign', color: 'white' }"
          :color="snackbar"
          :close-handler="closeSnackbar"
        />
      </div>
      <material-loading :active="loaderActive" />
    </div>
  </div>
</template>
<script>
import MaterialInput from "@/components/MaterialInput.vue";
import MaterialSnackbar from "@/components/MaterialSnackbar.vue";
import "bootstrap/dist/js/bootstrap.bundle";
import MaterialLoading from "@/components/MaterialLoading.vue";
import "bootstrap/js/dist/modal";
import MaterialButton from "@/components/MaterialButton.vue";
import "@vuepic/vue-datepicker/dist/main.css";
import SettingSlideService from "../../services/settingSlide.service";
import Multiselect from "@vueform/multiselect";
import "@vueform/multiselect/themes/default.css";
import MaterialCheckbox from "@/components/MaterialCheckbox.vue";
import Datepicker from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";
import CommonFunctionService from "../../services/commonFunction.service";
import TestService from "../../services/test.service";
import moment from "moment";
import $ from "jquery";
import draggable from 'vuedraggable'
import { scrollToFirstInvalid } from "@/config/utils";

export default {
  name: "slides",
  components: {
    MaterialSnackbar,
    MaterialLoading,
    MaterialButton,
    MaterialInput,
    Multiselect,
    Datepicker,
    MaterialCheckbox,
    draggable
  },
  data() {
    return {
      message: "",
      snackbar: null,
      loaderActive: false,
      fieldRequired: [],
      merchantCode: "",
      isLoadDoneData: false,
      urlImagePreview: [],
      messageImageError: [],
      isErrorUploadImage: [],
      isImageTooSmall: [],
      slides: [],
      tiers: [],
      disableBtnSubmit: false,
      textRequiredDateCustom: [],
      alwaysDisplayChecked: [],
      type: 1,
      branches: [],
      // MBR133: login background - URL on the server, picked file, its preview, cleared flag
      loginBg: "",
      loginBgFile: null,
      loginBgPreview: null,
      loginBgRemove: false,
      outletHeader: "",
      outletHeaderFile: null,
      outletHeaderPreview: null,
      outletHeaderRemove: false,
      branchIdSelect: 0,

      items: [],

      slidesOrderingHomepage: [],
      fieldRequiredOrderingHomepage: [],
      alwaysDisplayCheckedOrderingHomepage: [],
      textRequiredDateCustomOrderingHomepage: [],
      urlImagePreviewOrderingHomepage: [],
      messageImageErrorOrderingHomepage: [],
      isErrorUploadImageOrderingHomepage: [],
      isImageTooSmallOrderingHomepage: [],

      slidesOrderingCustompage: [],
      fieldRequiredOrderingCustompage: [],
      alwaysDisplayCheckedOrderingCustompage: [],
      textRequiredDateCustomOrderingCustompage: [],
      urlImagePreviewOrderingCustompage: [],
      messageImageErrorOrderingCustompage: [],
      isErrorUploadImageOrderingCustompage: [],
      isImageTooSmallOrderingCustompage: [],

      slidesOrderingCheckoutpage: [],
      fieldRequiredOrderingCheckoutpage: [],
      alwaysDisplayCheckedOrderingCheckoutpage: [],
      textRequiredDateCustomOrderingCheckoutpage: [],
      urlImagePreviewOrderingCheckoutpage: [],
      messageImageErrorOrderingCheckoutpage: [],
      isErrorUploadImageOrderingCheckoutpage: [],
      isImageTooSmallOrderingCheckoutpage: [],

      slidesOrderingLandingPage: [],
      fieldRequiredOrderingLandingPage: [],
      alwaysDisplayCheckedOrderingLandingPage: [],
      textRequiredDateCustomOrderingLandingPage: [],
      urlImagePreviewOrderingLandingPage: [],
      messageImageErrorOrderingLandingPage: [],
      isErrorUploadImageOrderingLandingPage: [],
      isImageTooSmallOrderingLandingPage: [],

      slidesKioskLandingpage: [],
      fieldRequiredKioskLandingpage: [],
      alwaysDisplayCheckedKioskLandingpage: [],
      textRequiredDateCustomKioskLandingpage: [],
      urlImagePreviewKioskLandingpage: [],
      messageImageErrorKioskLandingpage: [],
      isErrorUploadImageKioskLandingpage: [],
      isImageTooSmallKioskLandingpage: [],
    };
  },
  created() {
    this.getSlide();
    this.getLoginBackground();
  },
  mounted() {
    const code = localStorage.getItem("MERCHANT_CODE", "");
    this.merchantCode = code ? `/${code}` : "";
  },
  methods: {
    changeTab(type) {
      $("#general-tab .nav-link").removeClass("active");
      $("#nav_item_" + type).addClass("active");
      this.type = type;
      this.branchIdSelect = 0;
      if(type == 1) {
        this.branchIdSelect = 0;
        this.getSlide();
      }
      if (type == 2 || type == 3) {
        this.getBranches();
      }
      if (type == 4) {
        this.getOutletListHeader();
      }
    },
    format(date) {
      return CommonFunctionService.formatDateShow(date)
    },
    dateTimeFormat(startDate, startTime) {
      if (startDate == null) {
        return null;
      } else {
        if (startTime == null) {
          return moment(startDate).format("YYYY-MM-DD") + " " + "00:00:00";
        } else {
          return (
            moment(startDate).format("YYYY-MM-DD") +
            " " +
            moment(startTime).format("H:m")
          );
        }
      }
    },
    handleFileUpload(event, index) {
      let file = event.target.files[0];
      if (file != null || file != undefined) {
        if (
          !["image/png", "image/jpg", "image/jpeg", "image/svg"].includes(
            file.type
          )
        ) {
          alert('File must be an image.');
        } else {
          let reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onload = (evt) => {
            let img = new Image();
            img.onload = () => {
              let width = img.width;
              let height = img.height;
              let ratio = width/height;

              if (ratio < 1.5 || ratio > 2.5) {
                alert('Please upload and image with 2:1 aspect ratio (Width/Height)');
              } else if (file.size / 1024 / 1024 > 10) {
                alert('File size must not exceed 10MB.');
              } else {
                this.slides[index].file_name = file;
                this.urlImagePreview[index] = URL.createObjectURL(file);
                this.isErrorUploadImage[index] = false;
              }
            };
            img.src = evt.target.result;
          };
        }
      } else {
        alert('File must be an image.');
      }
      $("#image_" + index)[0].value = '';
    },

    clearImage(index) {
      this.slides[index].file_name = null;
      this.urlImagePreview[index] = null;
      this.fieldRequired[index].isImageRequire = false;
      this.isErrorUploadImage[index] = false;
      this.isImageTooSmall[index] = false;
    },

    getBranches() {
      this.showLoader();
      TestService.getBranches().then(
        (response) => {
          if (response.data.result.isSuccess) {
            this.branches = response.data.data;
            setTimeout(() => {
              this.branchIdSelect = this.branches && this.branches[0] ? this.branches[0].value : 0;
              this.getSlide();
            }, 100)
          } else {
            this.message = response.data.result.message;
          }
          this.hideLoader();
        },
        (error) => {
          this.message = error;
          this.hideLoader();
        }
      );
    },

    getSlide() {
      this.isLoadDoneData = false;
      this.alwaysDisplayChecked = []
      this.showLoader();
      let dataForm = {
        type: this.type,
        branch_id: this.branchIdSelect
      }

      SettingSlideService.getDataSlide(dataForm).then(
        (response) => {
          if (response.data.result.isSuccess) {
            this.tiers = response.data.data.tiers;
            this.items = response.data.data.items;
            if(this.type == 1) {
              this.slides = response.data.data.data_slide_setting;
              this.slides.forEach((item) => {
                this.fieldRequired.push({
                  isImageRequire: false,
                  isDateRequire: false,
                  invalidLink: false
                });
                item.always_display == 1 ? this.alwaysDisplayChecked.push("true") : this.alwaysDisplayChecked.push("false")
              });
            } else if (this.type == 2) {
              this.slidesOrderingHomepage = response.data.data.data_slide_setting;
              this.slidesOrderingHomepage.forEach((item) => {
                this.fieldRequiredOrderingHomepage.push({
                  isImageRequire: false,
                  isDateRequire: false,
                  invalidLink: false
                });
                item.always_display == 1 ? this.alwaysDisplayCheckedOrderingHomepage.push("true") : this.alwaysDisplayCheckedOrderingHomepage.push("false")
              });
              this.slidesOrderingCustompage = response.data.data.data_slide_setting_custom;
              this.slidesOrderingCustompage.forEach((item) => {
                this.fieldRequiredOrderingCustompage.push({
                  isImageRequire: false,
                  isDateRequire: false,
                  invalidLink: false
                });
                item.always_display == 1 ? this.alwaysDisplayCheckedOrderingCustompage.push("true") : this.alwaysDisplayCheckedOrderingCustompage.push("false")
              });
              this.slidesOrderingCheckoutpage = response.data.data.data_slide_setting_checkout;
              this.slidesOrderingCheckoutpage.forEach((item) => {
                this.fieldRequiredOrderingCheckoutpage.push({
                  isImageRequire: false,
                  isDateRequire: false,
                  invalidLink: false
                });
                item.always_display == 1 ? this.alwaysDisplayCheckedOrderingCheckoutpage.push("true") : this.alwaysDisplayCheckedOrderingCheckoutpage.push("false")
              });
              this.slidesOrderingLandingPage = response.data.data.data_slide_landing_page;
              this.slidesOrderingLandingPage.forEach((item) => {
                this.fieldRequiredOrderingLandingPage.push({
                  isImageRequire: false,
                  isDateRequire: false,
                });
                item.always_display == 1 ? this.alwaysDisplayCheckedOrderingLandingPage.push("true") : this.alwaysDisplayCheckedOrderingLandingPage.push("false")
              });
            } else if (this.type == 3) {
              this.slidesKioskLandingpage = response.data.data.data_slide_kiosk_landing_page;
              this.slidesKioskLandingpage.forEach((item) => {
                this.fieldRequiredKioskLandingpage.push({
                  isImageRequire: false,
                  isDateRequire: false,
                  invalidLink: false
                });
                item.always_display == 1 ? this.alwaysDisplayCheckedKioskLandingpage.push("true") : this.alwaysDisplayCheckedKioskLandingpage.push("false")
              });
            }
            this.isLoadDoneData = true;
          } else {
            this.snackbar = "danger";
            this.message = response.data.result.message;
            this.setTimeOutNotification();
          }
          this.hideLoader();
        },
        (error) => {
          this.snackbar = "danger";
          this.message = error;
          this.hideLoader();
          this.setTimeOutNotification();
        }
      );
    },

    async saveSlide() {
      this.showLoader();
      var checkImageTooSmall = false;
      var checkisFileButNotImage = false;
      this.isImageTooSmall.forEach((item) => {
        if (item == true) {
          checkImageTooSmall = true;
        }
      });

      this.isImageTooSmall.forEach((item) => {
        if (item == true) {
          checkisFileButNotImage = true;
        }
      });
      if (
        !checkImageTooSmall &&
        !checkisFileButNotImage &&
        this.processValidate()
      ) {
        this.fieldRequired.forEach((slide) => {
          slide.isImageRequire = false;
        });
        this.objDataSave = {};
        this.objDataSave = this.slides;
        this.objDataSave.forEach((item) => {
          item.start_date = this.dateTimeFormat(
            item.start_date,
            item.start_time
          );
          item.end_date = this.dateTimeFormat(item.end_date, item.end_time);
          item.always_display = item.always_display ? 1 : 0;
        });
        await SettingSlideService.addOrUpdateSlide(this.objDataSave).then(
          (response) => {
            if (response.data.result.isSuccess) {
              this.snackbar = "success";
              this.message = "Save Slide Success";
              this.getSlide();
              this.setTimeOutNotification();
            } else {
              this.snackbar = "danger";
              this.message = response.data.result.message;
              this.setTimeOutNotification()
            }
            this.hideLoader();
          },
          (error) => {
            this.snackbar = "danger";
            this.message = error;
            this.hideLoader();
            this.setTimeOutNotification()
          }
        );
      } else {
        this.hideLoader();
      }
    },

    async onEndDragSlide() {
      if(this.slides && this.slides.length > 1) {
        this.showLoader();
        var dataForm = {
          orderSlides: this.slides
        };
        await SettingSlideService.updateSlidesOrder(dataForm).then(
          (response) => {
            if (response.data.result.isSuccess) {
              this.getSlide();
            } else {
              this.snackbar = "danger";
              this.message = response.data.result.message;
              this.setTimeOutNotification();
            }
            this.hideLoader();
          },
          (error) => {
            this.snackbar = "danger";
            this.message = error;
            this.hideLoader();
            this.setTimeOutNotification();
          }
        );
      }
    },

    resetRequired() {
      this.slides.forEach((item, index) => {
        this.fieldRequired[index].isDateRequire = false;
        this.fieldRequired[index].invalidLink = false;
      });
    },

    processValidate() {
      this.resetRequired();
      var isValid = true;
      this.slides.forEach((item, index) => {
        const dateFrom = this.dateTimeFormat(
          this.slides[index].start_date,
          this.slides[index].start_time
        );
        const dateTo = this.dateTimeFormat(
          this.slides[index].end_date,
          this.slides[index].end_time
        );

        if (dateFrom == null && dateTo != null) {
          this.fieldRequired[index].isDateRequire = true;
          this.textRequiredDateCustom[index] =
            "The start date field is required.";
          isValid = false;
        } else if (dateFrom != null && dateTo != null && dateFrom >= dateTo) {
          this.fieldRequired[index].isDateRequire = true;
          this.textRequiredDateCustom[index] =
            "The end date must be a date after start date.";
          isValid = false;
        }
        
        if (item.destination_link != "" && item.destination_link != null) {
          var urlRegex = '^(?:(?:http|https|ftp)://)(?:\\S+(?::\\S*)?@)?(?:(?:(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}(?:\\.(?:[0-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))|(?:(?:[a-z\\u00a1-\\uffff0-9]+-?)*[a-z\\u00a1-\\uffff0-9]+)(?:\\.(?:[a-z\\u00a1-\\uffff0-9]+-?)*[a-z\\u00a1-\\uffff0-9]+)*(?:\\.(?:[a-z\\u00a1-\\uffff]{2,})))|localhost)(?::\\d{2,5})?(?:(/|\\?|#)[^\\s]*)?$';
          var urlPattern = new RegExp(urlRegex, 'i');
    
          if (!urlPattern.test(item.destination_link)) {
            isValid = false;
            this.fieldRequired[index].invalidLink = true;
          }
        }
      });

      if (!isValid) {
        scrollToFirstInvalid();
      }

      return isValid;
    },

    closeSnackbar() {
      this.snackbar = null;
    },

    getLoginBackground() {
      SettingSlideService.getLoginBackground().then((response) => {
        if (response.data.result.isSuccess) {
          this.loginBg = response.data.data.mbr_login_bg_image || "";
        }
      });
    },
    uploadLoginBg() {
      $("#image_login_bg").click();
    },
    handleFileUploadLoginBg(event) {
      let file = event.target.files[0];
      if (!file || !["image/png", "image/jpg", "image/jpeg", "image/webp"].includes(file.type)) {
        alert('File must be a png, jpg/jpeg or webp image.');
      } else {
        this.loginBgFile = file;
        this.loginBgPreview = URL.createObjectURL(file);
        this.loginBgRemove = false;
      }
      $("#image_login_bg")[0].value = '';
    },
    clearLoginBg() {
      this.loginBgFile = null;
      this.loginBgPreview = null;
      this.loginBg = "";
      this.loginBgRemove = true;
    },
    saveLoginBackground() {
      let form = { remove: this.loginBgRemove ? 1 : 0 };
      if (this.loginBgFile) {
        form.mbr_login_bg_image = this.loginBgFile;
      }
      this.showLoader();
      SettingSlideService.saveLoginBackground(form).then(
        (response) => {
          if (response.data.result.isSuccess) {
            this.loginBg = response.data.data.mbr_login_bg_image || "";
            this.loginBgFile = null;
            this.loginBgPreview = null;
            this.loginBgRemove = false;
            this.snackbar = "success";
            this.message = "Save Login Background Success";
          } else {
            this.snackbar = "danger";
            this.message = response.data.result.message;
          }
          this.setTimeOutNotification();
          this.hideLoader();
        },
        (error) => {
          this.snackbar = "danger";
          this.message = error;
          this.setTimeOutNotification();
          this.hideLoader();
        }
      );
    },
    // SF307: header picture of the physical-branch outlet list - same flow as the login background.
    getOutletListHeader() {
      SettingSlideService.getOutletListHeader().then((response) => {
        if (response.data.result.isSuccess) {
          this.outletHeader = response.data.data.outlet_list_header_image || "";
        }
      });
    },
    uploadOutletHeader() {
      $("#image_outlet_header").click();
    },
    handleFileUploadOutletHeader(event) {
      let file = event.target.files[0];
      if (!file || !["image/png", "image/jpg", "image/jpeg", "image/webp"].includes(file.type)) {
        alert('File must be a png, jpg/jpeg or webp image.');
      } else {
        this.outletHeaderFile = file;
        this.outletHeaderPreview = URL.createObjectURL(file);
        this.outletHeaderRemove = false;
      }
      $("#image_outlet_header")[0].value = '';
    },
    clearOutletHeader() {
      this.outletHeaderFile = null;
      this.outletHeaderPreview = null;
      this.outletHeader = "";
      this.outletHeaderRemove = true;
    },
    saveOutletListHeader() {
      let form = { remove: this.outletHeaderRemove ? 1 : 0 };
      if (this.outletHeaderFile) {
        form.outlet_list_header_image = this.outletHeaderFile;
      }
      this.showLoader();
      SettingSlideService.saveOutletListHeader(form).then(
        (response) => {
          if (response.data.result.isSuccess) {
            this.outletHeader = response.data.data.outlet_list_header_image || "";
            this.outletHeaderFile = null;
            this.outletHeaderPreview = null;
            this.outletHeaderRemove = false;
            this.snackbar = "success";
            this.message = "Save Outlet List Header Success";
          } else {
            this.snackbar = "danger";
            this.message = response.data.result.message;
          }
          this.setTimeOutNotification();
          this.hideLoader();
        },
        (error) => {
          this.snackbar = "danger";
          this.message = error;
          this.setTimeOutNotification();
          this.hideLoader();
        }
      );
    },
    setTimeOutNotification() {
      setTimeout(() => {
        this.snackbar = null;
      }, 3000);
    },

    addRowSlide() {
      this.slides.push({
        id: null,
        index: this.slides.length,
        description: "1",
        file_name: null,
        ordering: 0,
        slide_tiers: ['all'],
        start_date: null,
        start_time: null,
        end_date: null,
        end_time: null,
        always_display: 0,
        destination_link: "",
        status: 1,
      });

      this.fieldRequired.push({
        isImageRequire: false,
        isDateRequire: false,
        invalidLink: false,
      });

      this.alwaysDisplayChecked.push(true)
    },

    removeRowSlide(index) {
      if (this.slides.length > 0) {
        this.slides.splice(index, 1);
        this.alwaysDisplayChecked.splice(index, 1);
      }
    },

    check($event, index) {
      this.alwaysDisplayChecked[index] = $event.target.value
    },

    uploadFile(index) {
      $("#image_" + index).click();
    },

    showLoader() {
      this.loaderActive = true;
    },
    hideLoader() {
      this.loaderActive = false;
    },

    addRowSlideOrderingHomePage() {
      this.slidesOrderingHomepage.push({
        id: null,
        index: this.slidesOrderingHomepage.length,
        description: "1",
        file_name: null,
        ordering: 0,
        slide_tiers: ['all'],
        start_date: null,
        start_time: null,
        end_date: null,
        end_time: null,
        always_display: 0,
        destination_link: "",
        status: 1,
        type: 2,
        branch_id: this.branchIdSelect,
        where_showing: 1
      });

      this.fieldRequiredOrderingHomepage.push({
        isImageRequire: false,
        isDateRequire: false,
        invalidLink: false
      });

      this.alwaysDisplayCheckedOrderingHomepage.push(true)
    },

    resetRequiredOrderingHomePage() {
      this.slidesOrderingHomepage.forEach((item, index) => {
        this.fieldRequiredOrderingHomepage[index].isDateRequire = false;
        this.fieldRequiredOrderingHomepage[index].invalidLink = false;
      });
    },

    processValidateOrderingHomePage() {
      this.resetRequiredOrderingHomePage();
      var isValid = true;
      this.slidesOrderingHomepage.forEach((item, index) => {
        const dateFrom = this.dateTimeFormat(
          this.slidesOrderingHomepage[index].start_date,
          this.slidesOrderingHomepage[index].start_time
        );
        const dateTo = this.dateTimeFormat(
          this.slidesOrderingHomepage[index].end_date,
          this.slidesOrderingHomepage[index].end_time
        );

        if (dateFrom == null && dateTo != null) {
          this.fieldRequiredOrderingHomepage[index].isDateRequire = true;
          this.textRequiredDateCustomOrderingHomepage[index] =
            "The start date field is required.";
          isValid = false;
        } else if (dateFrom != null && dateTo != null && dateFrom >= dateTo) {
          this.fieldRequiredOrderingHomepage[index].isDateRequire = true;
          this.textRequiredDateCustomOrderingHomepage[index] =
            "The end date must be a date after start date.";
          isValid = false;
        }

        if (item.destination_link != "" && item.destination_link != null) {
          var urlRegex = '^(?:(?:http|https|ftp)://)(?:\\S+(?::\\S*)?@)?(?:(?:(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}(?:\\.(?:[0-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))|(?:(?:[a-z\\u00a1-\\uffff0-9]+-?)*[a-z\\u00a1-\\uffff0-9]+)(?:\\.(?:[a-z\\u00a1-\\uffff0-9]+-?)*[a-z\\u00a1-\\uffff0-9]+)*(?:\\.(?:[a-z\\u00a1-\\uffff]{2,})))|localhost)(?::\\d{2,5})?(?:(/|\\?|#)[^\\s]*)?$';
          var urlPattern = new RegExp(urlRegex, 'i');
    
          if (!urlPattern.test(item.destination_link)) {
            isValid = false;
            this.fieldRequiredOrderingHomepage[index].invalidLink = true;
          }
        }
      });
      return isValid;
    },

    async saveSlideOrderingHomePage() {
      this.showLoader();
      var checkImageTooSmall = false;
      var checkisFileButNotImage = false;
      this.isImageTooSmallOrderingHomepage.forEach((item) => {
        if (item == true) {
          checkImageTooSmall = true;
        }
      });

      this.isImageTooSmallOrderingHomepage.forEach((item) => {
        if (item == true) {
          checkisFileButNotImage = true;
        }
      });
      if (
        !checkImageTooSmall &&
        !checkisFileButNotImage &&
        this.processValidateOrderingHomePage()
      ) {
        this.fieldRequiredOrderingHomepage.forEach((slide) => {
          slide.isImageRequire = false;
        });
        this.objDataSave = {};
        this.objDataSave = this.slidesOrderingHomepage;
        this.objDataSave.forEach((item) => {
          item.start_date = this.dateTimeFormat(
            item.start_date,
            item.start_time
          );
          item.end_date = this.dateTimeFormat(item.end_date, item.end_time);
          item.always_display = item.always_display ? 1 : 0;
        });
        if(this.slidesOrderingHomepage && this.slidesOrderingHomepage.length == 0) {
          this.objDataSave = [{
              type: 2,
              branch_id: this.branchIdSelect,
              where_showing: 1,
              isEmpty: 1
          }]
        }
        await SettingSlideService.addOrUpdateSlide(this.objDataSave).then(
          (response) => {
            if (response.data.result.isSuccess) {
              this.snackbar = "success";
              this.message = "Save Slide Success";
              this.getSlide();
              this.setTimeOutNotification();
            } else {
              this.snackbar = "danger";
              this.message = response.data.result.message;
              this.setTimeOutNotification()
            }
            this.hideLoader();
          },
          (error) => {
            this.snackbar = "danger";
            this.message = error;
            this.hideLoader();
            this.setTimeOutNotification()
          }
        );
      } else {
        this.hideLoader();
      }
    },

    async onEndDragSlideOrderingHomepage() {
      if(this.slidesOrderingHomepage && this.slidesOrderingHomepage.length > 1) {
        this.showLoader();
        var dataForm = {
          orderSlides: this.slidesOrderingHomepage
        };
        await SettingSlideService.updateSlidesOrder(dataForm).then(
          (response) => {
            if (response.data.result.isSuccess) {
              this.getSlide();
            } else {
              this.snackbar = "danger";
              this.message = response.data.result.message;
              this.setTimeOutNotification();
            }
            this.hideLoader();
          },
          (error) => {
            this.snackbar = "danger";
            this.message = error;
            this.hideLoader();
            this.setTimeOutNotification();
          }
        );
      }
    },

    removeRowSlideOrderingHomepage(index) {
      if (this.slidesOrderingHomepage.length > 0) {
        this.slidesOrderingHomepage.splice(index, 1);
        this.alwaysDisplayCheckedOrderingHomepage.splice(index, 1);
      }
    },

    clearImageOrderingHomepage(index) {
      this.slidesOrderingHomepage[index].file_name = null;
      this.urlImagePreviewOrderingHomepage[index] = null;
      this.fieldRequiredOrderingHomepage[index].isImageRequire = false;
      this.isErrorUploadImageOrderingHomepage[index] = false;
      this.isImageTooSmallOrderingHomepage[index] = false;
    },

    uploadFileOrderingHomepage(index) {
      $("#image_ordering_homepage_" + index).click();
    },

    handleFileUploadOrderingHomepage(event, index) {
      let file = event.target.files[0];
      if (file != null || file != undefined) {
        if (
          !["image/png", "image/jpg", "image/jpeg", "image/svg"].includes(
            file.type
          )
        ) {
          alert('File must be an image.');
        } else {
          let reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onload = (evt) => {
            let img = new Image();
            img.onload = () => {
              let width = img.width;
              let height = img.height;
              let ratio = width/height;

              if (ratio < 1.5 || ratio > 2.5) {
                alert('Please upload and image with 2:1 aspect ratio (Width/Height)');
              } else if (file.size / 1024 / 1024 > 10) {
                alert('File size must not exceed 10MB.');
              } else {
                this.slidesOrderingHomepage[index].file_name = file;
                this.urlImagePreviewOrderingHomepage[index] = URL.createObjectURL(file);
                this.isErrorUploadImageOrderingHomepage[index] = false;
              }
            };
            img.src = evt.target.result;
          };
        }
      } else {
        alert('File must be an image.');
      }
      $("#image_ordering_homepage_" + index)[0].value = '';
    },

    checkOrderingHomepage($event, index) {
      this.alwaysDisplayCheckedOrderingHomepage[index] = $event.target.value
    },

    changeBranches(branch_id) {
      this.slidesOrderingHomepage = [];
      this.fieldRequiredOrderingHomepage = [];
      this.alwaysDisplayCheckedOrderingHomepage = [];
      this.textRequiredDateCustomOrderingHomepage = [];
      this.urlImagePreviewOrderingHomepage = [];
      this.isErrorUploadImageOrderingHomepage = [];
      this.isImageTooSmallOrderingHomepage = [];

      this.slidesKioskLandingpage = [];
      this.fieldRequiredKioskLandingpage = [];
      this.alwaysDisplayCheckedKioskLandingpage = [];
      this.textRequiredDateKioskLandingpage = [];
      this.urlImagePreviewKioskLandingpage = [];
      this.isErrorUploadImageKioskLandingpage = [];
      this.isImageTooSmallKioskLandingpage = [];

      this.branchIdSelect = branch_id;
      this.getSlide();
    },

    // custom
    addRowSlideOrderingCustomPage() {
      this.slidesOrderingCustompage.push({
        id: null,
        index: this.slidesOrderingCustompage.length,
        description: "1",
        file_name: null,
        ordering: 0,
        slide_tiers: ['all'],
        start_date: null,
        start_time: null,
        end_date: null,
        end_time: null,
        always_display: 0,
        destination_link: "",
        status: 1,
        type: 2,
        branch_id: this.branchIdSelect,
        where_showing: 2,
        display_condition: 2,
        tags: '',
        clickablefunction: 2,
        direct_to_menu_item: 0
      });

      this.fieldRequiredOrderingCustompage.push({
        isImageRequire: false,
        isDateRequire: false,
        invalidLink: false
      });

      this.alwaysDisplayCheckedOrderingCustompage.push(true)
    },

    resetRequiredOrderingCustomPage() {
      this.slidesOrderingCustompage.forEach((item, index) => {
        this.fieldRequiredOrderingCustompage[index].isDateRequire = false;
        this.fieldRequiredOrderingCustompage[index].invalidLink = false;
      });
    },

    processValidateOrderingCustomPage() {
      this.resetRequiredOrderingCustomPage();
      var isValid = true;
      this.slidesOrderingCustompage.forEach((item, index) => {
        const dateFrom = this.dateTimeFormat(
          this.slidesOrderingCustompage[index].start_date,
          this.slidesOrderingCustompage[index].start_time
        );
        const dateTo = this.dateTimeFormat(
          this.slidesOrderingCustompage[index].end_date,
          this.slidesOrderingCustompage[index].end_time
        );

        if (dateFrom == null && dateTo != null) {
          this.fieldRequiredOrderingCustompage[index].isDateRequire = true;
          this.textRequiredDateCustomOrderingCustompage[index] =
            "The start date field is required.";
          isValid = false;
        } else if (dateFrom != null && dateTo != null && dateFrom >= dateTo) {
          this.fieldRequiredOrderingCustompage[index].isDateRequire = true;
          this.textRequiredDateCustomOrderingCustompage[index] =
            "The end date must be a date after start date.";
          isValid = false;
        }

        if (item.clickablefunction == 1) {
          if (item.destination_link != "" && item.destination_link != null) {
            var urlRegex = '^(?:(?:http|https|ftp)://)(?:\\S+(?::\\S*)?@)?(?:(?:(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}(?:\\.(?:[0-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))|(?:(?:[a-z\\u00a1-\\uffff0-9]+-?)*[a-z\\u00a1-\\uffff0-9]+)(?:\\.(?:[a-z\\u00a1-\\uffff0-9]+-?)*[a-z\\u00a1-\\uffff0-9]+)*(?:\\.(?:[a-z\\u00a1-\\uffff]{2,})))|localhost)(?::\\d{2,5})?(?:(/|\\?|#)[^\\s]*)?$';
            var urlPattern = new RegExp(urlRegex, 'i');
      
            if (!urlPattern.test(item.destination_link)) {
              isValid = false;
              this.fieldRequiredOrderingCustompage[index].invalidLink = true;
            }
          }
        }
      });
      return isValid;
    },

    async saveSlideOrderingCustomPage() {
      this.showLoader();
      var checkImageTooSmall = false;
      var checkisFileButNotImage = false;
      this.isImageTooSmallOrderingCustompage.forEach((item) => {
        if (item == true) {
          checkImageTooSmall = true;
        }
      });

      this.isImageTooSmallOrderingCustompage.forEach((item) => {
        if (item == true) {
          checkisFileButNotImage = true;
        }
      });
      if (
        !checkImageTooSmall &&
        !checkisFileButNotImage &&
        this.processValidateOrderingCustomPage()
      ) {
        this.fieldRequiredOrderingCustompage.forEach((slide) => {
          slide.isImageRequire = false;
        });
        this.objDataSave = {};
        this.objDataSave = this.slidesOrderingCustompage;
        this.objDataSave.forEach((item) => {
          item.start_date = this.dateTimeFormat(
            item.start_date,
            item.start_time
          );
          item.end_date = this.dateTimeFormat(item.end_date, item.end_time);
          item.always_display = item.always_display ? 1 : 0;
        });
        if(this.slidesOrderingCustompage && this.slidesOrderingCustompage.length == 0) {
          this.objDataSave = [{
              type: 2,
              branch_id: this.branchIdSelect,
              where_showing: 2,
              isEmpty: 1
          }]
        }
        await SettingSlideService.addOrUpdateSlide(this.objDataSave).then(
          (response) => {
            if (response.data.result.isSuccess) {
              this.snackbar = "success";
              this.message = "Save Slide Success";
              this.getSlide();
              this.setTimeOutNotification();
            } else {
              this.snackbar = "danger";
              this.message = response.data.result.message;
              this.setTimeOutNotification()
            }
            this.hideLoader();
          },
          (error) => {
            this.snackbar = "danger";
            this.message = error;
            this.hideLoader();
            this.setTimeOutNotification()
          }
        );
      } else {
        this.hideLoader();
      }
    },

    async onEndDragSlideOrderingCustompage() {
      if(this.slidesOrderingCustompage && this.slidesOrderingCustompage.length > 1) {
        this.showLoader();
        var dataForm = {
          orderSlides: this.slidesOrderingCustompage
        };
        await SettingSlideService.updateSlidesOrder(dataForm).then(
          (response) => {
            if (response.data.result.isSuccess) {
              this.getSlide();
            } else {
              this.snackbar = "danger";
              this.message = response.data.result.message;
              this.setTimeOutNotification();
            }
            this.hideLoader();
          },
          (error) => {
            this.snackbar = "danger";
            this.message = error;
            this.hideLoader();
            this.setTimeOutNotification();
          }
        );
      }
    },

    removeRowSlideOrderingCustompage(index) {
      if (this.slidesOrderingCustompage.length > 0) {
        this.slidesOrderingCustompage.splice(index, 1);
        this.alwaysDisplayCheckedOrderingCustompage.splice(index, 1);
      }
    },

    clearImageOrderingCustompage(index) {
      this.slidesOrderingCustompage[index].file_name = null;
      this.urlImagePreviewOrderingCustompage[index] = null;
      this.fieldRequiredOrderingCustompage[index].isImageRequire = false;
      this.isErrorUploadImageOrderingCustompage[index] = false;
      this.isImageTooSmallOrderingCustompage[index] = false;
    },

    uploadFileOrderingCustompage(index) {
      $("#image_ordering_custompage_" + index).click();
    },

    handleFileUploadOrderingCustompage(event, index) {
      let file = event.target.files[0];
      if (file != null || file != undefined) {
        if (
          !["image/png", "image/jpg", "image/jpeg", "image/svg"].includes(
            file.type
          )
        ) {
          alert('File must be an image.');
        } else {
          let reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onload = (evt) => {
            let img = new Image();
            img.onload = () => {
              let width = img.width;
              let height = img.height;
              let ratio = width/height;

              if (ratio < 1.5 || ratio > 2.5) {
                alert('Please upload and image with 2:1 aspect ratio (Width/Height)');
              } else if (file.size / 1024 / 1024 > 10) {
                alert('File size must not exceed 10MB.');
              } else {
                this.slidesOrderingCustompage[index].file_name = file;
                this.urlImagePreviewOrderingCustompage[index] = URL.createObjectURL(file);
                this.isErrorUploadImageOrderingCustompage[index] = false;
              }
            };
            img.src = evt.target.result;
          };
        }
      } else {
        alert('File must be an image.');
      }
      $("#image_ordering_custompage_" + index)[0].value = '';
    },

    checkOrderingCustompage($event, index) {
      this.alwaysDisplayCheckedOrderingCustompage[index] = $event.target.value
    },

    // checkout
    addRowSlideOrderingCheckoutPage() {
      this.slidesOrderingCheckoutpage.push({
        id: null,
        index: this.slidesOrderingCheckoutpage.length,
        description: "1",
        file_name: null,
        ordering: 0,
        slide_tiers: ['all'],
        start_date: null,
        start_time: null,
        end_date: null,
        end_time: null,
        always_display: 0,
        destination_link: "",
        status: 1,
        type: 2,
        branch_id: this.branchIdSelect,
        where_showing: 3,
        display_condition: 2,
        tags: '',
        clickablefunction: 2,
        direct_to_menu_item: 0
      });

      this.fieldRequiredOrderingCheckoutpage.push({
        isImageRequire: false,
        isDateRequire: false,
        invalidLink: false
      });

      this.alwaysDisplayCheckedOrderingCheckoutpage.push(true)
    },

    resetRequiredOrderingCheckoutPage() {
      this.slidesOrderingCheckoutpage.forEach((item, index) => {
        this.fieldRequiredOrderingCheckoutpage[index].isDateRequire = false;
        this.fieldRequiredOrderingCheckoutpage[index].invalidLink = false;
      });
    },

    processValidateOrderingCheckoutPage() {
      this.resetRequiredOrderingCheckoutPage();
      var isValid = true;
      this.slidesOrderingCheckoutpage.forEach((item, index) => {
        const dateFrom = this.dateTimeFormat(
          this.slidesOrderingCheckoutpage[index].start_date,
          this.slidesOrderingCheckoutpage[index].start_time
        );
        const dateTo = this.dateTimeFormat(
          this.slidesOrderingCheckoutpage[index].end_date,
          this.slidesOrderingCheckoutpage[index].end_time
        );

        if (dateFrom == null && dateTo != null) {
          this.fieldRequiredOrderingCheckoutpage[index].isDateRequire = true;
          this.textRequiredDateCheckoutOrderingCheckoutpage[index] =
            "The start date field is required.";
          isValid = false;
        } else if (dateFrom != null && dateTo != null && dateFrom >= dateTo) {
          this.fieldRequiredOrderingCheckoutpage[index].isDateRequire = true;
          this.textRequiredDateCheckoutOrderingCheckoutpage[index] =
            "The end date must be a date after start date.";
          isValid = false;
        }

        if (item.clickablefunction == 1) {
          if (item.destination_link != "" && item.destination_link != null) {
            var urlRegex = '^(?:(?:http|https|ftp)://)(?:\\S+(?::\\S*)?@)?(?:(?:(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}(?:\\.(?:[0-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))|(?:(?:[a-z\\u00a1-\\uffff0-9]+-?)*[a-z\\u00a1-\\uffff0-9]+)(?:\\.(?:[a-z\\u00a1-\\uffff0-9]+-?)*[a-z\\u00a1-\\uffff0-9]+)*(?:\\.(?:[a-z\\u00a1-\\uffff]{2,})))|localhost)(?::\\d{2,5})?(?:(/|\\?|#)[^\\s]*)?$';
            var urlPattern = new RegExp(urlRegex, 'i');
      
            if (!urlPattern.test(item.destination_link)) {
              isValid = false;
              this.fieldRequiredOrderingCheckoutpage[index].invalidLink = true;
            }
          }
        }
      });
      return isValid;
    },

    async saveSlideOrderingCheckoutPage() {
      this.showLoader();
      var checkImageTooSmall = false;
      var checkisFileButNotImage = false;
      this.isImageTooSmallOrderingCheckoutpage.forEach((item) => {
        if (item == true) {
          checkImageTooSmall = true;
        }
      });

      this.isImageTooSmallOrderingCheckoutpage.forEach((item) => {
        if (item == true) {
          checkisFileButNotImage = true;
        }
      });
      if (
        !checkImageTooSmall &&
        !checkisFileButNotImage &&
        this.processValidateOrderingCheckoutPage()
      ) {
        this.fieldRequiredOrderingCheckoutpage.forEach((slide) => {
          slide.isImageRequire = false;
        });
        this.objDataSave = {};
        this.objDataSave = this.slidesOrderingCheckoutpage;
        this.objDataSave.forEach((item) => {
          item.start_date = this.dateTimeFormat(
            item.start_date,
            item.start_time
          );
          item.end_date = this.dateTimeFormat(item.end_date, item.end_time);
          item.always_display = item.always_display ? 1 : 0;
        });
        if(this.slidesOrderingCheckoutpage && this.slidesOrderingCheckoutpage.length == 0) {
          this.objDataSave = [{
              type: 2,
              branch_id: this.branchIdSelect,
              where_showing: 3,
              isEmpty: 1
          }]
        }
        await SettingSlideService.addOrUpdateSlide(this.objDataSave).then(
          (response) => {
            if (response.data.result.isSuccess) {
              this.snackbar = "success";
              this.message = "Save Slide Success";
              this.getSlide();
              this.setTimeOutNotification();
            } else {
              this.snackbar = "danger";
              this.message = response.data.result.message;
              this.setTimeOutNotification()
            }
            this.hideLoader();
          },
          (error) => {
            this.snackbar = "danger";
            this.message = error;
            this.hideLoader();
            this.setTimeOutNotification()
          }
        );
      } else {
        this.hideLoader();
      }
    },

    async onEndDragSlideOrderingCheckoutpage() {
      if(this.slidesOrderingCheckoutpage && this.slidesOrderingCheckoutpage.length > 1) {
        this.showLoader();
        var dataForm = {
          orderSlides: this.slidesOrderingCheckoutpage
        };
        await SettingSlideService.updateSlidesOrder(dataForm).then(
          (response) => {
            if (response.data.result.isSuccess) {
              this.getSlide();
            } else {
              this.snackbar = "danger";
              this.message = response.data.result.message;
              this.setTimeOutNotification();
            }
            this.hideLoader();
          },
          (error) => {
            this.snackbar = "danger";
            this.message = error;
            this.hideLoader();
            this.setTimeOutNotification();
          }
        );
      }
    },

    removeRowSlideOrderingCheckoutpage(index) {
      if (this.slidesOrderingCheckoutpage.length > 0) {
        this.slidesOrderingCheckoutpage.splice(index, 1);
        this.alwaysDisplayCheckedOrderingCheckoutpage.splice(index, 1);
      }
    },

    clearImageOrderingCheckoutpage(index) {
      this.slidesOrderingCheckoutpage[index].file_name = null;
      this.urlImagePreviewOrderingCheckoutpage[index] = null;
      this.fieldRequiredOrderingCheckoutpage[index].isImageRequire = false;
      this.isErrorUploadImageOrderingCheckoutpage[index] = false;
      this.isImageTooSmallOrderingCheckoutpage[index] = false;
    },

    uploadFileOrderingCheckoutpage(index) {
      $("#image_ordering_checkoutpage_" + index).click();
    },

    handleFileUploadOrderingCheckoutpage(event, index) {
      let file = event.target.files[0];
      if (file != null || file != undefined) {
        if (
          !["image/png", "image/jpg", "image/jpeg", "image/svg"].includes(
            file.type
          )
        ) {
          alert('File must be an image.');
        } else {
          let reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onload = (evt) => {
            let img = new Image();
            img.onload = () => {
              let width = img.width;
              let height = img.height;
              let ratio = width/height;

              if (ratio < 1.5 || ratio > 2.5) {
                alert('Please upload and image with 2:1 aspect ratio (Width/Height)');
              } else if (file.size / 1024 / 1024 > 10) {
                alert('File size must not exceed 10MB.');
              } else {
                this.slidesOrderingCheckoutpage[index].file_name = file;
                this.urlImagePreviewOrderingCheckoutpage[index] = URL.createObjectURL(file);
                this.isErrorUploadImageOrderingCheckoutpage[index] = false;
              }
            };
            img.src = evt.target.result;
          };
        }
      } else {
        alert('File must be an image.');
      }
      $("#image_ordering_checkoutpage_" + index)[0].value = '';
    },

    checkOrderingCheckoutpage($event, index) {
      this.alwaysDisplayCheckedOrderingCheckoutpage[index] = $event.target.value
    },

    // landing page
    addRowSlideOrderingLandingPage() {
      this.slidesOrderingLandingPage.push({
        id: null,
        index: this.slidesOrderingLandingPage.length,
        description: "1",
        file_name: null,
        ordering: 0,
        slide_tiers: ['all'],
        start_date: null,
        start_time: null,
        end_date: null,
        end_time: null,
        always_display: 0,
        destination_link: "",
        status: 1,
        type: 2,
        branch_id: this.branchIdSelect,
        where_showing: 4,
        display_condition: 2,
        tags: '',
        clickablefunction: 2,
        direct_to_menu_item: 0
      });

      this.fieldRequiredOrderingLandingPage.push({
        isImageRequire: false,
        isDateRequire: false,
      });

      this.alwaysDisplayCheckedOrderingLandingPage.push(true)
    },

    resetRequiredOrderingLandingPage() {
      this.slidesOrderingLandingPage.forEach((item, index) => {
        this.fieldRequiredOrderingLandingPage[index].isDateRequire = false;
      });
    },

    processValidateOrderingLandingPage() {
      this.resetRequiredOrderingLandingPage();
      var isValid = true;
      this.slidesOrderingLandingPage.forEach((item, index) => {
        const dateFrom = this.dateTimeFormat(
          this.slidesOrderingLandingPage[index].start_date,
          this.slidesOrderingLandingPage[index].start_time
        );
        const dateTo = this.dateTimeFormat(
          this.slidesOrderingLandingPage[index].end_date,
          this.slidesOrderingLandingPage[index].end_time
        );
        if (dateFrom == null && dateTo != null) {
          this.fieldRequiredOrderingLandingPage[index].isDateRequire = true;
          this.textRequiredDateCheckoutOrderingLandingPage[index] =
            "The start date field is required.";
          isValid = false;
        } else if (dateFrom != null && dateTo != null && dateFrom >= dateTo) {
          this.fieldRequiredOrderingLandingPage[index].isDateRequire = true;
          this.textRequiredDateCheckoutOrderingLandingPage[index] =
            "The end date must be a date after start date.";
          isValid = false;
        }
      });
      return isValid;
    },

    async saveSlideOrderingLandingPage() {
      this.showLoader();
      var checkImageTooSmall = false;
      var checkisFileButNotImage = false;
      this.isImageTooSmallOrderingLandingPage.forEach((item) => {
        if (item == true) {
          checkImageTooSmall = true;
        }
      });

      this.isImageTooSmallOrderingLandingPage.forEach((item) => {
        if (item == true) {
          checkisFileButNotImage = true;
        }
      });
      if (
        !checkImageTooSmall &&
        !checkisFileButNotImage &&
        this.processValidateOrderingLandingPage()
      ) {
        this.fieldRequiredOrderingLandingPage.forEach((slide) => {
          slide.isImageRequire = false;
        });
        this.objDataSave = {};
        this.objDataSave = this.slidesOrderingLandingPage;
        this.objDataSave.forEach((item) => {
          item.start_date = this.dateTimeFormat(
            item.start_date,
            item.start_time
          );
          item.end_date = this.dateTimeFormat(item.end_date, item.end_time);
          item.always_display = item.always_display ? 1 : 0;
        });
        if(this.slidesOrderingLandingPage && this.slidesOrderingLandingPage.length == 0) {
          this.objDataSave = [{
              type: 2,
              branch_id: this.branchIdSelect,
              where_showing: 4,
              isEmpty: 1
          }]
        }
        // console.log(this.objDataSave);
        await SettingSlideService.addOrUpdateSlide(this.objDataSave).then(
          (response) => {
            if (response.data.result.isSuccess) {
              this.snackbar = "success";
              this.message = "Save Slide Success";
              this.getSlide();
              this.setTimeOutNotification();
            } else {
              this.snackbar = "danger";
              this.message = response.data.result.message;
              this.setTimeOutNotification()
            }
            this.hideLoader();
          },
          (error) => {
            this.snackbar = "danger";
            this.message = error;
            this.hideLoader();
            this.setTimeOutNotification()
          }
        );
      } else {
        this.hideLoader();
      }
    },

    async onEndDragSlideOrderingLandingPage() {
      if(this.slidesOrderingLandingPage && this.slidesOrderingLandingPage.length > 1) {
        this.showLoader();
        var dataForm = {
          orderSlides: this.slidesOrderingLandingPage
        };
        await SettingSlideService.updateSlidesOrder(dataForm).then(
          (response) => {
            if (response.data.result.isSuccess) {
              this.getSlide();
            } else {
              this.snackbar = "danger";
              this.message = response.data.result.message;
              this.setTimeOutNotification();
            }
            this.hideLoader();
          },
          (error) => {
            this.snackbar = "danger";
            this.message = error;
            this.hideLoader();
            this.setTimeOutNotification();
          }
        );
      }
    },

    removeRowSlideOrderingLandingPage(index) {
      if (this.slidesOrderingLandingPage.length > 0) {
        this.slidesOrderingLandingPage.splice(index, 1);
        this.alwaysDisplayCheckedOrderingLandingPage.splice(index, 1);
      }
    },

    clearImageOrderingLandingPage(index) {
      this.slidesOrderingLandingPage[index].file_name = null;
      this.urlImagePreviewOrderingLandingPage[index] = null;
      this.fieldRequiredOrderingLandingPage[index].isImageRequire = false;
      this.isErrorUploadImageOrderingLandingPage[index] = false;
      this.isImageTooSmallOrderingLandingPage[index] = false;
    },

    uploadFileOrderingLandingPage(index) {
      $("#image_ordering_landing_page_" + index).click();
    },

    handleFileUploadOrderingLandingPage(event, index) {
      let file = event.target.files[0];
      if (file != null || file != undefined) {
        if (
          !["image/png", "image/jpg", "image/jpeg", "image/svg"].includes(
            file.type
          )
        ) {
          alert('File must be an image.');
        } else {
          let reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onload = (evt) => {
            let img = new Image();
            img.onload = () => {
              // let width = img.width;
              // let height = img.height;
              // let ratio = width/height;

              // if (ratio < 1.5 || ratio > 2.5) {
              //   alert('Please upload and image with 2:1 aspect ratio (Width/Height)');
              // } else 
              if (file.size / 1024 / 1024 > 10) {
                alert('File size must not exceed 10MB.');
              } else {
                this.slidesOrderingLandingPage[index].file_name = file;
                this.urlImagePreviewOrderingLandingPage[index] = URL.createObjectURL(file);
                this.isErrorUploadImageOrderingLandingPage[index] = false;
              }
            };
            img.src = evt.target.result;
          };
        }
      } else {
        alert('File must be an image.');
      }
      $("#image_ordering_landing_page_" + index)[0].value = '';
    },

    checkOrderingLandingPage($event, index) {
      this.alwaysDisplayCheckedOrderingLandingPage[index] = $event.target.value
    },

    handleBackPosition(index) {
      if (index > 0) {
        const movedItem = this.slidesOrderingLandingPage.splice(index, 1)[0];
        this.slidesOrderingLandingPage.splice(index - 1, 0, movedItem);
        this.onEndDragSlideOrderingLandingPage();
      }
    },

    handleNextPosition(index) {
      if (index < this.slidesOrderingLandingPage.length - 1) {
        const movedItem = this.slidesOrderingLandingPage.splice(index, 1)[0];
        this.slidesOrderingLandingPage.splice(index + 1, 0, movedItem);
        this.onEndDragSlideOrderingLandingPage();
      }
    },

    //Kiosk landing page
    addRowSlideKioskLandingpage() {
      this.slidesKioskLandingpage.push({
        id: null,
        index: this.slidesKioskLandingpage.length,
        description: "1",
        file_name: null,
        ordering: 0,
        slide_tiers: ['all'],
        start_date: null,
        start_time: null,
        end_date: null,
        end_time: null,
        always_display: 0,
        destination_link: "",
        status: 1,
        type: 3,
        branch_id: this.branchIdSelect,
        where_showing: 1
      });

      this.fieldRequiredKioskLandingpage.push({
        isImageRequire: false,
        isDateRequire: false,
        invalidLink: false
      });

      this.alwaysDisplayCheckedKioskLandingpage.push(true)
    },

    async saveSlideKioskLandingpage() {
      this.showLoader();
      var checkImageTooSmall = false;
      var checkisFileButNotImage = false;
      this.isImageTooSmallKioskLandingpage.forEach((item) => {
        if (item == true) {
          checkImageTooSmall = true;
        }
      });

      this.isImageTooSmallKioskLandingpage.forEach((item) => {
        if (item == true) {
          checkisFileButNotImage = true;
        }
      });
      if (
        !checkImageTooSmall &&
        !checkisFileButNotImage &&
        this.processValidateKioskLandingpage()
      ) {
        this.fieldRequiredKioskLandingpage.forEach((slide) => {
          slide.isImageRequire = false;
        });
        this.objDataSave = {};
        this.objDataSave = this.slidesKioskLandingpage;
        this.objDataSave.forEach((item) => {
          item.start_date = this.dateTimeFormat(
            item.start_date,
            item.start_time
          );
          item.end_date = this.dateTimeFormat(item.end_date, item.end_time);
          item.always_display = item.always_display ? 1 : 0;
        });
        if(this.slidesKioskLandingpage && this.slidesKioskLandingpage.length == 0) {
          this.objDataSave = [{
              type: 2,
              branch_id: this.branchIdSelect,
              where_showing: 1,
              isEmpty: 1
          }]
        }
        await SettingSlideService.addOrUpdateSlide(this.objDataSave).then(
          (response) => {
            if (response.data.result.isSuccess) {
              this.snackbar = "success";
              this.message = "Save Slide Success";
              this.getSlide();
              this.setTimeOutNotification();
            } else {
              this.snackbar = "danger";
              this.message = response.data.result.message;
              this.setTimeOutNotification()
            }
            this.hideLoader();
          },
          (error) => {
            this.snackbar = "danger";
            this.message = error;
            this.hideLoader();
            this.setTimeOutNotification()
          }
        );
      } else {
        this.hideLoader();
      }
    },

    processValidateKioskLandingpage() {
      this.resetRequiredKioskLandingpage();
      var isValid = true;
      this.slidesKioskLandingpage.forEach((item, index) => {
        const dateFrom = this.dateTimeFormat(
          this.slidesKioskLandingpage[index].start_date,
          this.slidesKioskLandingpage[index].start_time
        );
        const dateTo = this.dateTimeFormat(
          this.slidesKioskLandingpage[index].end_date,
          this.slidesKioskLandingpage[index].end_time
        );

        if (dateFrom == null && dateTo != null) {
          this.fieldRequiredKioskLandingpage[index].isDateRequire = true;
          this.textRequiredDateCustomKioskLandingpage[index] =
            "The start date field is required.";
          isValid = false;
        } else if (dateFrom != null && dateTo != null && dateFrom >= dateTo) {
          this.fieldRequiredKioskLandingpage[index].isDateRequire = true;
          this.textRequiredDateCustomKioskLandingpage[index] =
            "The end date must be a date after start date.";
          isValid = false;
        }

        if (item.destination_link != "" && item.destination_link != null) {
          var urlRegex = '^(?:(?:http|https|ftp)://)(?:\\S+(?::\\S*)?@)?(?:(?:(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}(?:\\.(?:[0-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))|(?:(?:[a-z\\u00a1-\\uffff0-9]+-?)*[a-z\\u00a1-\\uffff0-9]+)(?:\\.(?:[a-z\\u00a1-\\uffff0-9]+-?)*[a-z\\u00a1-\\uffff0-9]+)*(?:\\.(?:[a-z\\u00a1-\\uffff]{2,})))|localhost)(?::\\d{2,5})?(?:(/|\\?|#)[^\\s]*)?$';
          var urlPattern = new RegExp(urlRegex, 'i');
    
          if (!urlPattern.test(item.destination_link)) {
            isValid = false;
            this.fieldRequiredKioskLandingpage[index].invalidLink = true;
          }
        }
      });
      return isValid;
    },

    resetRequiredKioskLandingpage() {
      this.slidesKioskLandingpage.forEach((item, index) => {
        this.fieldRequiredKioskLandingpage[index].isDateRequire = false;
        this.fieldRequiredKioskLandingpage[index].invalidLink = false;
      });
    },

    removeRowSlideKioskLandingpage(index) {
      if (this.slidesKioskLandingpage.length > 0) {
        this.slidesKioskLandingpage.splice(index, 1);
        this.alwaysDisplayCheckedKioskLandingpage.splice(index, 1);
      }
    },

    clearImageKioskLandingpage(index) {
      this.slidesKioskLandingpage[index].file_name = null;
      this.urlImagePreviewKioskLandingpage[index] = null;
      this.fieldRequiredKioskLandingpage[index].isImageRequire = false;
      this.isErrorUploadImageKioskLandingpage[index] = false;
      this.isImageTooSmallKioskLandingpage[index] = false;
    },

    uploadFileKioskLandingpage(index) {
      $("#image_kiosk_landingpage_" + index).click();
    },

    handleFileUploadKioskLandingpage(event, index) {
      let file = event.target.files[0];
      if (file != null || file != undefined) {
        if (
          !["image/png", "image/jpg", "image/jpeg", "image/svg"].includes(
            file.type
          )
        ) {
          alert('File must be an image.');
        } else {
          let reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onload = (evt) => {
            let img = new Image();
            img.onload = () => {
              if (file.size / 1024 / 1024 > 10) {
                alert('File size must not exceed 10MB.');
              } else {
                this.slidesKioskLandingpage[index].file_name = file;
                this.urlImagePreviewKioskLandingpage[index] = URL.createObjectURL(file);
                this.isErrorUploadImageKioskLandingpage[index] = false;
              }
            };
            img.src = evt.target.result;
          };
        }
      } else {
        alert('File must be an image.');
      }
      $("#image_kiosk_landingpage_" + index)[0].value = '';
    },

    checkKioskLandingpage($event, index) {
      this.alwaysDisplayCheckedKioskLandingpage[index] = $event.target.value
    },
  },
};
</script>
<style scoped>
.card-body .label-form {
  color: black !important;
  font-weight: 600 !important;
  font-size: 15px !important;
  font-family: "Roboto Slab", sans-serif !important;
}

.tag-a-custom {
  color: #007bff !important;
  text-decoration: underline !important;
  cursor: pointer;
}

#preview img {
  max-width: 150px;
  max-height: 100px;
}

#slide_list .multiselect-date input {
  max-width: 200px !important;
}

#slide_list .multiselect-time input {
  max-width: 100px !important;
}

.textarea-slide {
  max-width: 600px;
}

.custom-label {
  max-width: 200px !important;
  white-space: normal;
}

/* new css */
.slide-box {
  background: hsla(0, 0%, 100%, .5);
  border: 1px solid #d6d6d6;
  padding: 15px;
  border-radius: 5px;
  margin-top: 15px;
  cursor: move;
}

.upload-size-hint {
  margin-top: 6px;
  font-size: 12px;
  font-style: italic;
  color: #6c757d;
}

.slide-box .dowload-img {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: #f0f2f5;
  width: 100%;
  aspect-ratio: 2 / 1;
  cursor: pointer;
}

.slide-box .dowload-img.landing {
  aspect-ratio: 1 / 1.78;
}

/* SF265: Landing Page Sliding Banner hiển thị trên advocado bằng object-fit:
   contain trong khung ~4:5, nên preview ở đây phải cùng tỉ lệ — khung 2:1 dùng
   chung sẽ ép ảnh dọc thành dẹt và trông như ảnh hỏng. */
.slide-box .dowload-img.portrait-45 {
  aspect-ratio: 4 / 5;
}

.slide-box .css-icon-upload {
  font-size: 45px !important;
  margin-top: 6rem;
}

.slide-box .image-url {
  width: 100%;
  aspect-ratio: 2 / 1;
  max-width: 100% !important;
  max-height: 100% !important;
}

.slide-box .image-url.portrait-45 {
  aspect-ratio: 4 / 5;
  object-fit: contain;
}

/* SF307: the outlet list header is a fixed 1080 x 1440 (3:4) picture. */
.slide-box .dowload-img.portrait-34,
.slide-box .image-url.portrait-34 {
  aspect-ratio: 3 / 4;
}

/* MBR133: the member sign-in hero covers its box, so preview it the same way. */
.slide-box.login-bg-box {
  cursor: default;
}

.slide-box .image-url.login-bg-img {
  object-fit: cover;
}

.slide-box .image-url.landing {
  aspect-ratio: 1 / 1.78 !important;
}

.slide-box.slide-scheduled .image-url {
  opacity: 0.5;
}

.schedule-tag {
  position: absolute;
  bottom: 0;
  right: 0;
  background: #133067  !important;
  color: #ffffff;
  padding: 3px 10px;
  font-weight: bold;
}

.slide-box .btn-edit-img {
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  color: #f44335;
  font-size: 14px;
  right: 30px;
  top: 4px;
  background: #ffffff;
  border-radius: 50%;
}

.min-w-50px {
  min-width: 50px !important;
}

.row-flex {
  display: flex;
  flex-wrap: wrap;
}

.row-flex > [class*="col-"] {
  margin-bottom: 15px;
}

.row-flex > [class*="col-"] > .slide-box {
  height: calc(100% - 15px);
}
</style>